// upload/c_scale,f_auto,q_auto:low,w_1000/

import {
  lifeStoryDesc,
  friendsDesc,
  travelsDesc,
  hobbiesDesc,
  inHisMemoryDesc,
} from './descriptionData';
import {
  lifeStoryImages,
  friendsImages,
  travelImages,
  hobbiesImages,
  inHisMemoryImages,
} from './topicImagesData';

export const lifeStory = {
  title: 'lifeStory',
  details: null,
  topicImages: [
    {
      category: 'firstYears',
      title: 'השנים הראשונות 1985-1991',
      description: lifeStoryDesc.firstYears,
      images: lifeStoryImages.firstYears,
    },
    {
      category: 'elementarySchool',
      title: 'תקופת בי"ס יסודי 1992-1998',
      description: lifeStoryDesc.elementarySchool,
      images: lifeStoryImages.elementarySchool,
    },
    {
      category: 'highSchool',
      title: 'תקופת חט"ב ותיכון 1998-2004',
      description: lifeStoryDesc.highSchool,
      images: lifeStoryImages.highSchool,
    },
    {
      category: 'army',
      title: 'צבא ומילואים 2004-2018',
      description: lifeStoryDesc.army,
      images: lifeStoryImages.army,
    },
    {
      category: 'jerusalem',
      title: 'י-ם - לימודים ועוד 2011-2014',
      description: lifeStoryDesc.jerusalem,
      images: lifeStoryImages.jerusalem,
    },
    {
      category: 'telAviv',
      title: 'ת"א - לימודים ועוד 2015-2019',
      description: lifeStoryDesc.telAviv,
      images: lifeStoryImages.telAviv,
    },
    {
      category: 'work',
      title: 'עבודה, משפחה ובית',
      description: lifeStoryDesc.work,
      images: lifeStoryImages.work,
    },
  ],
};

export const friends = {
  title: 'friends',
  details: `
		ליונתן היו מעגלים רבים של חברים במשך חייו. בתקופת ילדות ובי"ס היסודי, היה לו מעגל מצומצם עם חברים קרובים, רובם מכיתתו או משכבתו (כמו מעין, חן, אהוד, אייל קינן וארז יניב),  ובחט"ב התרחב המעגל עם כמה ילדים נוספים (כמו גיל וקס, אייל אייזיק ואלעד ליבוביץ). בכיתה י' הצטרף יונתן לצופים, ופתאום התווסף מעגל חדש של כ-15 חבר'ה שהפכו די מהר להיות חבורה של חברים "אחים". מתקופת הצופים ובמשך ה-18 השנים הבאות, היו נפגשים, מבלים ומטיילים ביחד בכל הזדמנות אפשרית.<br><br>
		עם השנים, התווספו מעגלי חברים חדשים: מהצבא ומילואים, מהטיולים בחו"ל, מהלימודים לתואר ראשון, ממידברן וממקומות עבודה שונים. לעיתים הייתה חפיפה בין המעגלים - למשל, כשחברים מהצופים או ממקום עבודה התיידדו עם חברים ממידברן או עם חברים מהלימודים. לעיתים קרובות החפיפה הייתה ביוזמתו של יונתן ובזכות יכולתו המיוחדת להתחבר עם אנשים שונים ולחבר ביניהם.<br><br>
		<u>כך כתבו החברים מהלימודים בחוברת  "סיפורים ותמונות – יונתן גורן",  שחיברו לזכרו ביוני 2019:</u><br>
    <i>"זה כמעט בלתי נתפס, אבל יונתן היה חבר טוב כמעט של כל אחד במחזור שלנו באוניברסיטה. הוא היה מעין חוליה מגשרת בין חבורות שונות ובין אנשים עם אופי שונה. איכשהו כולם הצליחו להתחבר אליו, וכולם נהנו לבלות איתו - בטיולים, בסיורים של האוניברסיטה, בנסיעות לחו"ל, או סתם ביומיום... בלמידה, בילויים או כדורגל, יונתן היה נוכח כולו בחוויה. תכונה זו הפכה את השהייה בסביבתו לחוויה מהנה במיוחד, מאחר ותמיד הקדיש את הזמן והאנרגיה שלו לסובבים אותו באותו הרגע".</i>
    `,

  topicImages: [
    {
      category: 'brothersInScool',
      title: `חברים אחים - צוות רייצ'ל`,
      description: friendsDesc.brothersInScool,
      images: friendsImages.brothersInScool,
    },
    // {
    // 	category: 'brothers',
    // 	title: 'חברים אחים - אחרי תיכון',
    // 	description: friendsDesc.brothers,
    // 	images: friendsImages.brothers
    // },
    {
      category: 'otherFriend',
      title: 'חברים נוספים',
      description: friendsDesc.otherFriend,
      images: friendsImages.otherFriend,
    },
  ],
};

export const travel = {
  title: 'travel',
  details: `יונתן תמיד אהב להיות בחוץ ובטבע – "ילד טבע" עם הרבה אנרגיה מהשנים הראשונות. כבר מגיל צעיר מאוד אהב את הטיולים המשפחתיים והקבוצתיים שלנו בארץ ובחו"ל, במיוחד את טיולי הטבע, בהם היה מתרוצץ באוויר הפתוח ללא רסן.  בתקופת הלימודים בבי"ס, בזמן שהיה מכין מטלות ומתכונן למבחנים, היה מרגיש לחץ לעשות הפסקות לפעילות פיזית כלשהי – כדורגל או סתם ריצה. עם השנים הוא פיתח סקרנות ולמד גם לעצור בדרך כדי לבדוק, לחקור ולהבין את סביבתו ולהכיר את בני האדם החיים בה. אהבה זו התפתחה מאוד בתקופת הצופים, כשמצא אפשרויות והזדמנויות חדשות לתת לה ביטוי - טיולים, מחנות ואירועים מסוגים שונים -  והתחיל לגלות עניין וכישורים גם ברמת התכנון ויישומו המעשי. האהבה לטיולים ולטבע המשיכה להתפתח בתקופת השירות הצבאי, בה גילה עוד יכולות חשובות למטייל – כישורי ניווט וכושר פיזי מצויינים.<br><br>
  אבל רק שנה אחרי השחרור הפכה אהבה זו לאהבה גדולה באמת -  עם הטיול הגדול.  זה היה הטיול שעורר  אצלו את הדחף והסקרנות להכיר את העולם כולו ומגוון התרבויות שיש בו,  וסלל את הדרך לטיולים נוספים מסוגים שונים. זמן קצר אחרי שחזר מטיול זה, כבר התחיל  לחשוב על  הטיול הבא, וכך נוצר דפוס  חיים מסוים שליווה אותו בשנים הבאות. ביחד עם אהבה ענקית זו, התבלטו  בכל הטיולים שתי תכונות אופי: דחף לניצול מירבי של הזמן ונחישות לממש תוכניות ויעדים שנהג לקבוע לעצמו. יונתן הצליח לדחוס ליום טיול  עוד אירועים ובילויים עד מאוחר בלילה, וליהנות מכולם. טיולים, פעילות חברתית ובילויים רדפו אלה את אלה בקצב הייחודי שלו, דבר שלעיתים הוביל למצבי לחץ ותסכול,  אבל בעיקר הביא לו הרבה מאוד ריגושים, הנאה וסיפוק!`,
  topicImages: [
    {
      category: 'bigTrip',
      title: 'הטיול הגדול 2008-9',
      description: travelsDesc.bigTrip,
      images: travelImages.bigTrip,
    },
    {
      category: 'africa',
      title: 'אפריקה 2010',
      description: travelsDesc.africa,
      images: travelImages.africa,
    },
    {
      category: 'europeFirst',
      title: 'אירופה 2011-2',
      description: travelsDesc.europeFirst,
      images: travelImages.europeFirst,
    },
    {
      category: 'georgia',
      title: 'גיאורגיה 2013',
      description: travelsDesc.georgia,
      images: travelImages.georgia,
    },
    {
      category: 'australia',
      title: 'אוסטרליה וניו זילנד 2014',
      description: travelsDesc.australia,
      images: travelImages.australia,
    },
    {
      category: 'greece',
      title: 'יוון והולנד 2014',
      description: travelsDesc.greece,
      images: travelImages.greece,
    },
    {
      category: 'usa',
      title: 'ארה"ב 2015',
      description: travelsDesc.usa,
      images: travelImages.usa,
    },
    {
      category: 'europeSecond',
      title: 'אירופה 2016-8',
      description: travelsDesc.europeSecond,
      images: travelImages.europeSecond,
    },
    {
      category: 'southAmerica',
      title: 'דרום אמריקה 2019',
      description: travelsDesc.southAmerica,
      images: travelImages.southAmerica,
    },
  ],
};

export const hobbies = {
  title: 'hobbies',
  details: null,
  topicImages: [
    {
      category: 'sport',
      title: 'ספורט',
      description: hobbiesDesc.sport,
      images: hobbiesImages.sport,
    },
    {
      category: 'scouts',
      title: 'צופים',
      description: hobbiesDesc.scouts,
      images: hobbiesImages.scouts,
    },
    {
      category: 'midburn',
      title: 'מידברן',
      description: hobbiesDesc.midburn,
      images: hobbiesImages.midburn,
    },
  ],
};

export const dayAfter = {
  title: 'dayAfter',
  details: null,
  topicImages: [
    {
      category: 'eulogy',
      title: 'הספדים',
      description: 'משפחה וחברים מספידים',
      images:
        'https://res.cloudinary.com/yonatan-memorial/image/upload/c_scale,f_auto,q_auto:low,w_1000/v1620411705/DayAfter/eulogy_te88ts.jpg',
      // 'https://cairnsfuneraldirectors.com.au/wp-content/uploads/2019/07/shutterstock_1191446908.jpg'
    },
    {
      category: 'inHisMemory',
      // category: 'memoryEvening',
      title: 'ארועים לזכרו',
      description: 'ארועי זיכרון שנערכו',
      images:
        'https://res.cloudinary.com/yonatan-memorial/image/upload/c_scale,f_auto,q_auto:low,w_1000/v1620411866/DayAfter/memoryEvening_l5uj5w.jpg',
    },
    {
      category: 'memorial',
      title: 'הנצחה',
      description: 'יוזמות שנעשו ונעשות להנצחת יונתן',
      images:
        'https://res.cloudinary.com/yonatan-memorial/image/upload/c_scale,f_auto,q_auto:low,w_1000/v1644094156/DayAfter/memorial.jpg',
    },
    {
      category: 'videos',
      title: 'סרטונים',
      description: 'צילומי וידאו',
      images:
        'https://res.cloudinary.com/yonatan-memorial/image/upload/c_scale,f_auto,q_auto:low,w_1000/v1639228109/videosCover.jpg',
    },
    {
      category: 'friendsRemember',
      title: 'זיכרונותינו מיונתן',
      description: 'משפחה וחברים משתפים בחוויותיהם עם יונתן',
      images:
        'https://res.cloudinary.com/yonatan-memorial/image/upload/c_scale,f_auto,q_auto:low,w_1000/v1620239146/DayAfter/friendsRemember_tgzz7j.jpg',
    },
  ],
};

export const dayAfterEulogy = {
  title: 'dayAfterEulogy',
  details: null,
  topicImages: [
    {
      category: '2019',
      title: '2019',
      description: 'הספדים מ2019',
      images:
        'https://res.cloudinary.com/yonatan-memorial/image/upload/c_scale,f_auto,q_auto:low,w_1000/v1644096087/DayAfter/eulogy2019_adfoes.jpg',
      // 'https://res.cloudinary.com/yonatan-memorial/image/upload/c_scale,f_auto,q_auto:low,w_1000/v1620410951/DayAfter/2019eulogy_g1dovg.jpg',
    },
    {
      category: '2020',
      title: '2020',
      description: 'הספדים מ2020',
      images:
        'https://res.cloudinary.com/yonatan-memorial/image/upload/c_scale,f_auto,q_auto:low,w_1000/v1644095873/DayAfter/eulogy2020_pv7h4e.jpg',
      // 'https://res.cloudinary.com/yonatan-memorial/image/upload/c_scale,f_auto,q_auto:low,w_1000/v1620411449/DayAfter/2020eulogy_if7xxi.jpg',
    },
    {
      category: '2021',
      title: '2021',
      description: 'הספדים מ2021',
      images:
        'https://res.cloudinary.com/yonatan-memorial/image/upload/c_scale,f_auto,q_auto:low,w_1000/v1644095885/DayAfter/eulogy2021_zgfvft.jpg',
    },
    {
      category: '2022',
      title: '2022',
      description: 'הספדים מ2022',
      images:
        'https://res.cloudinary.com/yonatan-memorial/image/upload/c_scale,f_auto,q_auto:low,w_1000/v1653638781/DayAfter/eulogy2022_walklr.jpg',
    },
    {
      category: '2023',
      title: '2023',
      description: 'הספדים מ2023',
      images:
        'https://res.cloudinary.com/yonatan-memorial/image/upload/c_scale,f_auto,q_auto:low,w_1000/DayAfter/eulogy2023.jpg',
    },
    {
      category: '2024',
      title: '2024',
      description: 'הספדים מ2024',
      images:
        'https://res.cloudinary.com/yonatan-memorial/image/upload/c_scale,f_auto,q_auto:low,w_1000/v1715776560/DayAfter/eulogy2024.jpg',
    },
    {
      category: '2025',
      title: '2025',
      description: 'הספדים מ2025',
      images:
        'https://res.cloudinary.com/yonatan-memorial/image/upload/c_scale,f_auto,q_auto:low,w_1000/v1749714296/DayAfter/2025.jpg',
    },
    {
      category: '2026',
      title: '2026',
      description: 'הספדים מ2026',
      images:
        'https://res.cloudinary.com/yonatan-memorial/image/upload/v1780514064/DayAfter/2026_fovmwv.png',
    },
    // {
    //   category: 'moniPaper',
    //   title: 'כתבה במגזין בלייזר',
    //   description: 'החבר הקרוב מוני כותב',
    //   images:
    //     'https://res.cloudinary.com/yonatan-memorial/image/upload/c_scale,f_auto,q_auto:low,w_1000/v1620410760/DayAfter/moniPaper_f2mzwe.jpg',
    // },
  ],
};

export const eulogy = {
  moshe_goren: `
		יונתן,<br/>
		קיבלנו אותך כאשר היינו בגיל מבוגר, תינוק חייכן שקט שנהנה מעולמו ואין לו טענות לעולם הסובב אותו. גדלת והיית לילד ביישן בעל עולם פנימי גדול המסוגל לבלות שעות ארוכות במשחקים עם עצמו לבד מבלי להרגיש משועמם.<br/><br/>
		עם השנים רכשת לעצמך חברים בבית הספר ובהמשך בצופים, גם בהמשך מסלול חייך בצבא בלימודים בירושלים ובתל-אביב, באוסטרליה ובכל אשר פנית. ידעת לשמר חברויות אלו בהשקעת חום, רוחב לב, יוזמות יצירתיות והשקעת זמן רב. אם היינו יכולים לקבץ ולמנות את כל החברים והחברות שנוצרו לך במשך השנים היינו מגיעים למאות רבות.<br/><br/>
		גדלת להיות עלם יפה, חכם וחזק עם נפש גדולה ורצון לבלוע את העולם. הספקת לטייל בחלקים גדולים של העולם לראות ולחוות נופים אנשים וחוויות ולא היה בך שובע, רצית להמשיך עוד ועוד. הספקת להעפיל למרבית פסגות ההרים בעולם, רגעים אלו של מראות ונופים האדירים וההשתלבות שלך עם הטבע, נתנו לך סיפוק רב. במסעותיך הרבים לא היית מוכן להתפשר על פחות  מהיעדים שקבעת לעצמך ולכן העדפת לצאת לבד כדי שאחרים לא יסיטו אותך מהמסלול, מהנופים או מהקצב בו רצית לטייל.<br/>
		בטיול האחרון בדרום אמריקה. הספקת לבקר בכל השמורות וטיפסת על כל ההרים בפטגוניה, לצערי לא ויתרת גם על ההר האחרון שנשאר לפני הנסיעה לסנטיאגו בהמשך הטיול ושם נפלת, הר אחד יותר מדי.<br/><br/>
		היית בן אוהב ומסור בכל לבבך למשפחה הגרעינית וגם למשפחה המורחבת, דאגת לשלומנו ולהרגשתנו מכל מקום בו היית. שמחת שנסענו לטיול ביפן ומאוד נהנו, עודדת אותנו לנסיעה ליוון. העברת לנו תמונות ורשמים לאורך כל הטיול שלך, היה חשוב לך לשתף אותנו בחוויות וברגעים המהנים שאתה עובר, לשדר רוגע ולהראות שיש לך שליטה בכל המצבים ואין צורך בדאגה.<br/><br/>
		היית לך עמדת זינוק מצוינת לחיים, בסיס כלכלי חזק, סיימת את הלימודים, היית מוקף בהמון חברים ואנשים אוהבים , ניחנת בחכמה, ביופי וברגישות. נשארנו אמא ואבא לבד ללא תמיכה וסיוע ממך לעת זיקנה.<br/><br/>
		היה שלום בן יקר.
	`,
  ehud: `
		יונתן,<br/> 
		דרך ארוכה הלכנו יחד. כמעט 30 שנה שחיינו שזורים אלה באלה.<br>  
		מהמשפחתון של אתי, דרך הגן של רחל, ובכיתה לאורך כל השנים בבית הספר היסודי בן צבי.<br> 
		בחופשים נהגנו לבלות ימים שלמים במשחקים, בפעילויות משונות (בד"כ פרי המצאתך) וכמובן  בריבים. קצת כמו אחים. כשבגרנו והיינו כבר לחבורה גדולה (משנות החטיבה), היו מקומות שרק  שנינו דרכנו בהם. הכרנו היכרות אינטימית. ידענו לפרוט אחד על מיתריו של השני. שנינו עקשנים  שלא אוהבים לוותר ולכן גם לא פעם היו ביננו חילוקי דעות, אבל ידענו שלמרות הקשיים, הקשר  ביננו בלתי ניתן לניתוק. קצת כמו אחים.<br><br>
		היית הרפתקן. כבשת הרבה פסגות. אהבת את הריגוש שביציאה לדרך חדשה. אהבת את השטח,  להרגיש את הטבע ובעיקר – אהבת את המפגש עם האנשים שהדרך זימנה. הייתה בך פתיחות וצניעות  שאפשרו לכולם להרגיש איתך בנוח מהרגע הראשון. השקעת אנרגיה ומחשבה בכל אותם החברים  שאספת לאורך הדרך והצלחת לתת לכל אחד את התחושה שהוא חשוב לך. רבים כאן יודעים מה זה  לקבל ממך סרטון וידאו מאיזה פסגה אי שם, מכתב מרגש ליום הולדת או כל אחת מהמחוות  היצירתיות שעשית עבורנו. כמה מסירות ואכפתיות היו לך כשארגנת את ימי הספורט לפלוגה או את  כל אחת ממסיבות הרווקים בחבר'ה. וכמה שאהבת את החבר'ה. וכמה שהיית אהוב. וכמה שהיית  משמעותי בחבורה.<br> 
		אני יודע יונתן כמה הוריך היו יקרים לליבך ואני רוצה שתדע שמעתה הם יהיו חלק בלתי נפרד מחיינו.<br><br>
		אין זה סיכומה של חברות. לא ניתן לסכם בפסקה 30 שנים. אני אזכור מבט, חצי חיוך (מעט נבוך)  ואת הבעת פניך המגלות רגישות של אדם מופנם. אני אזכור נסיעות צפופות ביונדאי גטס קטנה  שמדהים כמה ציוד יכולת להכניס בתוכה (ובאיזה סדר). אני אזכור אותך מתעקש להכין קפה שחור על  גזייה אצלך בחצר, למרות שיש קומקום 5 מטרים ממך במטבח הבית. כי ככה היית, גם כשהיה לך  קשה ואפילו אם זה דרש ויתורים חברתיים, תמיד נשארת נאמן לעצמך, לעקרונותיך ולמצפונך.<br><br>
		לנצח אחי, אזכור אותך תמיד.<br><br>
		שלך,<br>
		אהוד.
	`,
  tom: `
		עוד פסגה<br>
		יונתן גורן חבר יקר. תמיד היית ותמיד תישאר.<br>
		אנחנו כאן היום רוצים להגיד לך תודה.<br>
		יש בנו כעס, ועצב והמון פחד ועם זאת - אנחנו רוצים להגיד לך תודה.<br>
		תודה שלימדת אותנו לטפס עד לפיסגה. עד לפסגות שלנו עצמן. דרכיך ראינו את עצמינו ונהיינו טובים יותר בשל כך.<br>
		תראה כמה אנשים הגיעו היום - כולם אוהבים אותך!<br>
		אני מקווה שאתה מרגיש את זה ולוקח את זה איתך. זאת אהבה.<br>
		ועם כל האנשים כאן טיפסת וחיפשת פסגות. כלכך הרבה מעגלים, כלכך הרבה חברים. נגעת בכלכך הרבה אנשים רק בגלל מי שאתה.<br>
		אז תודה גורן, על מי שאתה.<br>
		הכרנו אומנם בצבא במקום שיש בו מפקדים וחיילים ופקודות ומשימות אבל התקופה הזאת הייתה כאילו בעולם אחר. אנחנו אומרים תודה שהכרנו אותך בעולם ההוא ונשארנו חברים גם בעולם הזה.<br>
		בעולם הזה כבשנו עוד פסגה ביחד - או לחוד.<br>
		שיתפנו חוויות ביחד - או לבד. <br>
		ונתת לנו להרגיש ביחד - גם שלא היה אף אחד.<br>
		זה מי שאתה גורן - איש של אנשים, ושל ביחד ואיש של פסגות.<br>
		ועל ההר ההוא בצ'ילה הגעת לפסגה:<br>
		פסגת השקט והשלווה של עצמיך. תודה שהראית לנו שאפשר למצוא גם את זה.<br>
		אז גורן. אנחנו לא מבטיחים שנהיה בעד מכבי תל אביב, אבל מבטיחים שנהנה מכל זית שנאכל, נסיים את החמאת בוטנים ויהי מה, ונשתה קפה רק בפסגה.<br>
		אנחנו נמשיך לזכור את גבי - ואותך<br>
	`,
  ran1: `
		היית צריך להיות פה אחי, איך כולם מגיעים להיפגש. קבוצות שונות ממעגלי חברויות שונים נפגשים ומדברים. יהודית ואני לומדים להכיר את החברים שלך מהבית, מהצבא והם אותנו. המשפחה מגיעה, אשכרה מדברים בינינו אחי.<br> 
		מה שקורה כאן, בזמן שאנו מנסים לעכל את החדשות הנוראיות, שהתדפקו על דלתותינו רק לפני יומיים, יכל להיתפס בעיניך כהפקה שרק אולי דמיינת מוציא לפועל. האמת שגם במקרה הזה, זה אתה. אילולא אתה ומה שקרה, זה לא היה קורה. רק חבל לי שאתה לא פה גם להנות מזה.<br> 
		אתה יודע אחי, זה לא נתפס. הבנתי שנהרגת אבל בתוך תוכי יודע שעוד תחזור מהטיול, כמו מכל טיול אחר שממנו חזרת בעבר, מלא חוויות וקשרים חדשים שיצרת. תצור קשר ותרצה להזרים אותי על מפגש. לא משנה מה הפלטפורמה - בירה, טיול בטבע, אצלך או אצלי בדירה, באמת לא משנה, העיקר שניפגש. היית מספר על הטרק ההוא על הר הגעש ואיך כמעט מתת בגללו ומספר איך חילצו אותך ושסתם זו הייתה טעות, וכמה מזל היה לך. הייתי אומר לך שאתה דביל ותפסיק כבר עם השטויות האלה ודי לדחוף לקצה....
		אבל אתה עקשן אחי, היית מבטל בהינף יד את דבריי, לוגם עוד קצת מהבירה, ומראה לי עוד תמונה משוגעת של איזו פסגה נוספת שכבשת.<br>
		דיברנו יחד בראש השנה, בבית של ההורים שלך, בגינה, ליד אחד מהעצים שאבא שלך שתל. ביקשת סיגריה, אותה סיגריה אחת שהיית מקצה לעצמך ביום. דיברנו, כמו תמיד, על החיים, מה עם זוגיות, עבודה, התואר המעצבן שלך שאתה מת לסיים ולעוף כבר לטיול. אותו טיול ארור שממנו לא חזרת אלינו. אמרתי לך גם אז, שאני לא מבין את מטרת הטיול, שדי לברוח לחו"ל, מהחיים. שלא משנה לאן תסע ומה תהיה התפאורה, הבעיות נשארות אתנו. אבל לך נמאס ממרוץ החיים השגרתי. חגורת הלחצים החברתיים הלכה והתהדקה סביבך במעגל המשפחה והחברים. כולם עוברים שלבים, זוגיות, נישואים וילדים, אז נסעת, בדיוק כמו שתכננת.<br>
		אתה יודע, שקיבלתי את הבשורה ביום שישי בבוקר, צמד המילים "יונתן מת", לא יוצא לי מהראש. מיד הקלדתי את שמך בוואטספ. מתפלל שכן שלחתי לפחות הודעת תודה על הסרטון ששלחת לי ליומולדת. התחוורתי לראות במסך הוואטספ שלך את הסרטון המדובר ותחתיו שום דבר, אפס תגובה מצידי. הסכין שננעצה לי בלב, ננעצה עמוק יותר והסתובבה כמגבירה את תחושת הכאב הקר והחד. הלם, כעס, פספוס, עצבים על עצמי, אלו הם התחושות הראשונות שעלו בי.<br>
		רציתי לבקש סליחה אחי. סליחה שלא תמיד שמרתי איתך על קשר כמו שרצית, כמו שרצינו. שלא הייתי יותר קליל וסירבתי להצעות החוזרות שלך למפגש. סליחה שלא דיברתי איתך לפני הטיול, מעולם לא נפרדנו ואף פעם לא ניפרד.<br>
		ומה עכשיו אחי? ממשיכים כרגיל? עד מתי זה בסדר לבכות ומתי מחליטים שחוזרים לשגרה?<br>  
		חלמתי עליך היום בלילה. חלמתי שאתה צועד פנימה לבית של ההורים שלך שכולנו שם ביחד, כל החברים, משפחה, כל האנשים שבהם נגעת. אולי זה קרה כי כל הזמן שאני אצל ההורים שלך, אני יושב בשקט ומסתכל על הדלת, יודע שזה לא יקרה אבל מתפלל בפנים שהנה, אולי כן, כנגד כל הסיכויים, תכנס עם חיוך מבויש, מרגיש קצת אשם אבל בסתר ליבך שמח לראות כמה רלוונטי וחשוב היית לסובביך. אני אזכה לשמוע את צמד המילים "רן קטן" שכל כך מזוהה לי איתך בכל פעם שנפגשנו או דיברנו. הוא אולי יצליח לגבור על צמד המילים הנוראיות האחרות שנצרבו לי על הלב.<br>
		אוהב אותך אחי, מתגעגע בלי סוף ומבטיח לזכור תמיד,<br>
		הבן דוד הקטן שלך.
	`,
  ran2: `
		יום עברו מאז שטמנו אותך פה, באדמה שעליה גדלת. 30 יום של חשבון נפש עצמי. הסתכלות פנימה והחוצה. עלינו, עליך, על מי שאתה, איזה זיכרון אתה משאיר ומה אני משאיר אצלי ממך.<br>
		צחוקך מהדהד לי בראש לעיתים יותר ויותר תכופות. אני מדמיין את העיניים הצוחקות המתלוות לחיוך ולצחוק הייחודי הזה.<br>
		אני כל כך מפחד לשכוח קול, צחוק, מבט. סימנים ייחודיים שמעידים על האופי שלך.<br>
		ואני עדיין כועס ועצוב ולא מבין ומנסה למצוא כוחות להמשיך. כי חייבים. חייבים אבל.... לא תמיד רוצים.<br>
		השבעה נגמרה, ההמולה התפזרה, ואט אט חוזרים כל אחד ואחת לעיסוקו. אבל המחשבות מלוות ועולות. בעיקר בלבד או אפילו באירועים משמחים. בהם אני יודע שכבר לא תהיה, למרות שאני בטוח שרצית. וכשהן באות, הרגש מתגבר, ומוריד דמעות, שמעידות על עולם פנימי כואב, המום ושבור.<br>
		בלכתך מאתנו כך בטרם עת, השארת חור ענק בלב וכל כך הרבה שאלות ללא תשובות.<br>
		חבל שהלכת מאתנו יונתן, אני אוהב, מתגעגע בלי סוף ומסרב להאמין...<br><br>
		<u>שיר מאת אילן גולדהירש-</u><br>
		<i>"הלב נצבט ובגרון מחנק<br>
		והדמעות יורדות להן כמו גשם<br>
		ולא רואים דבר מרוב אבק<br>
		ומי יודע איך בכלל לגשת.<br><br>
		רוחות קרות הביתה נכנסות<br>
		אמת מרה טופחת על פנינו<br>
		ובאויר שתיקה קשה מנשוא<br>
		וערפל בזויות עינינו<br><br>	 
		כל כך קשה לכתוב דמעות, קשה לשאת את הדממה<br>
		כל כך קשה לשיר דמעות<br>
		ומי יתננו נחמה<br><br>	 
		וצל גדול יושב ממש מולך,<br>
		ענן שחור עוטף את הרקיע<br>
		וטלטלה אוחזת את כולך<br>
		אתה הולך, הולך ולא מגיע<br><br>	 
		שרק נמצא כוחות להתגבר שרק נמצא מילים בתוך האלם<br>
		המון מילים רוצות להיאמר וכל מילה בתוך דמעה נמהלת<br><br>"</i>
		מתגעגע ומבטיח לזכור ולקחת אותך איתי לכל מקום שבו אהיה,<br>
		הבן דוד הקטן שלך
	`,
  ran3: `
		הבקתה מעל משולש הגבולות בגולן. זה תמיד יהיה המקום שלנו. היינו בה כמה שנים לפני אותו טיול. הפעם רצינו למצוא אותה שוב. זוכר איך חיפשנו אותה ערב שלם? תחילה ברכב כדי למצוא את המקום ואז ברגל בשטח הפתוח. תכננו לישון בה את הלילה. אני זוכר שהגענו למקום והיא כבר לא הייתה שם. איזו אכזבה זו הייתה...<br>
		זה היה סופו של יום טיולים בגולן בין מעיינות, נופים, תצפיות ופק"לי קפה.<br>
		באותו הלילה הלכנו לישון על אחד מחופי הכנרת. שתינו כמה בירות והשיחה נפתחה. הדיבור היה אמיתי וכנה. בלי מסכות. זכיתי לראות אותך ולשמוע אותך בצורה האמיתית והגולמית ביותר. על הפחדים, האכזבות, החששות, על הרצון העז לזוגיות והעיסוק הבלתי פוסק בשאלה למה זה לא עובד...<br>
		אני זוכר ששיתפתי אותך בחוויות שלי מנסיוני בזוגיות, בקשיים הנפשיים שלי. מצאנו מכנה משותף בחלק מהדברים והצלחנו להכיל, להקשיב ולייעץ אחד לשני.<br>
		אפילו הקשבת לי והתחלת טיפול. במשך תקופה גם עדכנת מידי פעם על מה אתה עובר בתוכו ועל מה אתה מדבר. זו הייתה תקופה מאוד קרובה שלנו.<br>
		עד אז תמיד הייתה לי את ההרגשה שאתה כל כך משתדל לייצר בינינו איזו תחושה של אח גדול שמלמד ומסביר. ממלא חלל שהיה לך. וגם אהבתי את זה.<br>
		אבל מאז יחסי הכוחות השתנו. זה קרה, גם, כי גדלנו... ופערי הגיל והסטטוס החברתי נעשו פחות משמעותיים ואפילו דומים.<br>
		מאז, בכל מפגש הרגשתי שאנחנו מצליחים לייצר שיח פתוח, אמיתי ובוגר... כל אחד על תחומי העניין העכשוויים שלו.<br>
		יונתן, אתה נמצא אצלי כמעט בכל נקודה מרכזית בחיים- הכנה לצבא עם ריצות בשדות עמק חפר וסיפורים על ההכשרה שלך בצבא, הצבא עצמו עם עצות בניווטים, טיול גדול שנעשה ברובו על פי הנחיותיך המדוקדקות, המעבר של יהודית לארץ וכמה דאגת שתמיד תרגיש פה בנוח, תחילת הלימודים עם החששות לפני ואפילו תוך כדי, בעזרה צמודה בקורסי האקולוגיה והגיאומורפולוגיה.<br>
		לאחרונה, עוד רגע משמעותי קרה לי בחיים. הצעתי ליהודית נישואים אחי. ואתה כל כך חסר לי פה עכשיו. כמה אני רוצה לספר לך ולהשביע אותך, שכמו שהבטחת לי- את החתונה הזו אתה לא מפספס בגלל טיול בחו"ל.<br>
		יונתן, אתה נורא חסר לי פה. כל כך קשה לנסות להתרגל לרעיון שלא אראה אותך יותר לעולם.<br>
		יומולדת שמח תותח! אני אוהב ומתגעגע. יותר משמילים יכולות לתאר.<br>
		הבן דוד הקטן שלך.
	`,
  midburn: `
		<u>כך כתבה ליאת שבתאי, מחבריו של יונתן ממידברן 2018, שבועיים אחרי האסון</u><br>
		את הקטע הקריאה במעגל שירה לזכרו שהתקיים בכיכר הבימה. שם הקדשנו לו את השיר ״בן אדם עלה למעלה עלה״-<br><br>
		יונתן שלנו,<br>
		לפני 16 יום בלבד,  אי שם  רחוק מכאן, על פסגת הר הגעש שקיוות לכבוש, גופך חדל להיות עוד. ואנחנו שחיכינו לך פה בזרועות פתוחות, נשארנו המומים וכואבים. לא מאמינים שלא תחזור עוד.<br>
		יונתן, אומנם גופך כבה שם על ההר, אבל האור שלך הכל כך מיוחד ימשיך להאיר אותנו ולהיות חלק מהאנרגיה המתחוללת בנו ובינינו על האדמה הזו .בדרכך נגעת בכל כך הרבה אנשים ופתחת לבבות קדושים... היית לאור גדול.<br>
		היום, המעט שנוכל לעשות עבורך הוא לשיר לך כאן ביחד תפילה לרוחך ולמנוחתך שם למעלה, כאן במעגל הזה ובמעגלים נוספים בעולם. נשלח לך חיבוק גדול ואוהב כי היית אדם של לב ונתינה. אהבת את האדם ואת הטבע, את הורייך וחברייך. העזת להיות ולחיות את חייך עד הסוף, עד הפסגה האחרונה. היית בן אדם.
	`,
  yoav: `
		<u>The Climb, the Fall - Luke Thompson</u><br>
		<i>"Did you feel the limelight<br>
		Slipping away from your hold<br>
		Did you feel the darkness sinking into your soul<br>
		Glowing isn't easy and nobody wants<br>
		To feel forgotten, to be forgot<br>
		Amy died running through the night<br>
		Trying to hide from the quiet inside<br>
		But you never can, you never will, it's yours<br>
		Takes it's toll all that rock n roll<br>
		It takes another little piece of your heart and soul<br>
		But we're all climb but not the fall"</i><br><br>
		This PhD thesis is in memory of my dearest friend Yonatan Goren who was always by my side when I needed him but unfortunately, left us too soon. Yonatan, I hope you're still climbing high snowy mountains, reaching fresh peaks and watching the horizon as you always loved. You are a true inspiration for those wanting to live their life to its fullest. You're deeply missed
	`,
  adam_barak: `
		שנה אחרי...<br>
		לפני שנה בדיוק נסענו כליל ואני לחגוג את היומולדת של כליל לא רחוק מכאן והתעוררנו לאותו בוקר שישי מזוויע וארור. המנכ"ל שלי העיר אותי ב6:00 בבוקר עם הידיעה הנוראית על המוות שלך, אחרי שעה בערך הצלחתי להביא את עצמי להעיר את כליל ואז עוד שעה וחצי עד שהצלחתי להעלות על הכתב הודעה לחבר'ה ששינתה לכולנו את החיים. אחרי זה כבר הכל רץ הרבה יותר מהר, התקפלנו בכמה דקות ויצאנו חזרה לתל אביב במהירות, לא יכולתי לחשוב על אנשים אחרים שאני רוצה להיות איתם חוץ מהחבר'ה. התקבצנו כולנו אצלנו בדירה ובילינו כל היום מכונסים בתוך עצמנו, מעשנים סיגריות בצרורות ומדברים עליך בזמן הווה, עוד לפני שבכלל הצלחנו לעכל שהלכת מאיתנו.<br><br>
		השנה הזאת הייתה מורכבת לכולנו, אף אחד מאיתנו לא באמת הצליח להבין מה קרה ואם זה אמיתי. חלקנו חלמנו חלומות, חלקנו העסקנו את עצמנו באלף משימות, אבל שום דבר לא עזר מלמנוע שתופיע אצלנו בראש באיזה רמזור אדום, בזמן בהייה ממושכת במחשב או במחשבות לפני השינה.<br><br>
		שנה אחרי אני מתעורר בשישי בבוקר בבקתה במושב אניעם, לא רחוק מאיפה שהיינו אז, וזה סוף שבוע של היומולדת של כליל והכל נראה לי אחרת עכשיו. אני יושב עם קפה מסתכל על הטבע שנפרש מולי ועל המרחבים לטיול והדבר הראשון שעולה לי לראש זה אתה.
		בדיוק שנה אחרי...<br><br>
		יונתן, גם עכשיו אחרי שנה קשה לי לרשום את השם שלך בלי שעולות לי דמעות לעיניים, קשה לעכל שאני לא אראה אותך יותר. יום שישי נעלה לקבר שלך והמצבה מאבן תראה כאילו היא שם כבר שנים, בלי לדעת שהיא שם רק שנה ושהאיש המדהים ששוכב מתחתיה כל כך חסר לנו.<br><br>
		מתגעגעים ואוהבים, רייצ'ל.
	`,
  ran4: `
		בהתחלה, עוד כילדים, זה היה לחנהל׳ה. בהמשך לסבא ואז לסבתא. עוד אחד ממפגשי המשפחה שיצרו הזדמנות להיפגש ולהתעדכן. לא להאמין שנוספת לרשימת האזכרות.<br> 
		בשנה החולפת, המון קרה והזמן חלף, אך נדמה כי כשמחשבותיי נודדות אליך ואל המקרה, כאילו הזמן עצר מלכת. אני עוד שם, בסיוט המתמשך שהחל מרגע קבלת הידיעה.  והתחושות, הן אותן התחושות והתהום, אותה תהום. קטיעת חייך מתוך חיינו בצורה כה מהירה וללא שום התראה, היא טראומה שחיה בתוכי, בכל יום מחדש.<br>
		שעון פנימי, חבוי, סודי, החל לרוץ בי ברגע ששלך פסק. שעון שאי אפשר לעצור, כמו כל שעון. שעון שאני כל כך רוצה להחזיר אחורה על מנת שאוכל לדבר, להזהיר, לבקש.<br>
		והזמן, הוא לא באמת מרפא. הוא מוהל את הכאב בהמון דברים אחרים. אבל שמנקים את אותם הדברים, הכאב עדיין כאן, חי ודוקר. המוח מבין אך הלב מסרב להאמין, שכבר לא.<br>
		נעלמת ולא תשוב.<br>
		יונתן, אחי, הגעגועים לא פסקו, רק התגברו אל מול חסרונך בחיי.<br>
		שיר, מקום, מפגש, אירוע, שמחה ועצב. כל אלו פורטים על מיתרי הלב בתורם, מעלים את זיכרונך ומדגישים את חסרונך.<br>
		מתגעגע לדברים הכי פשוטים שיש - פק״ל קפה, שיחה אמיתית וכנה באמצע החיים, חיבוק של מפגש, ושל פרידה. מגע, קול, צחוק, מבט...<br>
		מתגעגע אליך אחי.<br>
		עכשיו שקט, אתה לא פה. אבל אני פה, זוכר, מתגעגע ואוהב.<br><br>
		<u>אקריא חלק משיר שכתב דוד גרוסמן-</u><br>
		<i>"קצר וחטוף ושובר את הלב<br>
		לחשוב שהוא תכף ידעך<br>
		מבטו רק נפקח<br>
		אך התחיל ללבלב-<br>
		רק ניתן לי ותכף נלקח.<br><br>
		ואת ואני היודעים<br>
		ונורא הדבר שרק הוא לא-<br>
		עד כמה קצרים החיים,<br>
		החיים הקצרים שניתנו לו.<br><br>
		נדיב ונסער ומכאיב<br>
		קצר פה כל כך<br>
		האביב."</i><br><br>
		הבן דוד הקטן שלך.
	`,
  shira: `
    יונתן,<br>
    החיים שלנו שוטפים, ימים מתחלפים, עונות משתנות, ילדים גדלים. והראש לא יודע להבין את ההתנגשות הזו, בין הזמן שעצר שם במאי 2019, ובין הזמן שלעולם לא עוצר. אתה נמצא שם כצל, מופיע בכל מיני פינות, לפעמים בלתי צפויות. אני מדמיינת אותך יושב בפינה ומתבונן עם החיוך שלך, המבויש, החושב, האוהב. היתה שנה לא נורמאלית במיוחד, ומצאתי עצמי לא פעם חושבת מה היית אומר על זה, מה היית חושב על זה, איך היית מעכל את הטירוף הזה מסביב. לא, זה לא היה בשבילך, חשבתי לעצמי ואולי ניסיתי למצוא נחמה. רצית עולם של פעם, איטי יותר, קרוב יותר, פשוט יותר, עולם של טבע וחיבור ושקט ושלום, כזה שמסתכלים בו בעיניים ולא דרך מסיכות, כזה שרואים בו אחד את השני. לא ויתרת על הרצון הזה, על החיפוש הזה, וכל מפגש איתך היה פיסת עולם כזה, אני מתגעגעת לזה.<br><br>
    ואפילו ככה ברגע יומיומי, בספר הילדים שקראנו, מצאתי אותך.<br>
    "הם ירדו לנהר והתישבו על מעקה הגשר, וטלטלו את רגליהם מעל המים. השמש עמדה עתה מעל לצמרות העצים והאירה הישר בפניהם... סנופקין ישב והכין סירות מעלים של צמח הקנה והשיט אותם במורד הנהר.<br>
    "לאן הן שטות?" שאל מומינטרול.<br>
    "למקומות שאני לא שם" אמר סנופקין. סירה אחר סירה פנתה בעיקול הנהר ונעלמה.<br>
    "שאלת על תוכניות", אמר מומינטרול, "לך יש תוכנית?"<br>
    "כן," אמר סנופקין. "יש לי תוכנית. אבל אני אממש אותה לבדי, אתה מבין?"<br>
    מומינטרול הביט בו זמן רב. לבסוף אמר:<br>
    "אתה חושב לצאת לדרך".<br>
    סנופקין הנהן.<br>
    הם ישבו עוד זמן מה בלי להחליף מילה, מנדנדים את רגליהם מעל המים. הנהר זרם תחתיהם הלאה והלאה, הרחק למקומות הזרים שסנופקין נכסף אליהם ושאליהם ינדוד לגמרי לבדו.<br>
    "מתי אתה יוצא?" שאל מומינטרול.<br>
    "תכף ומיד!" אמר סנופקין והשליך את כל סירות העלים למים בבת אחת. הוא ירד בקפיצה ממעקה הגשר ורחרח את אויר הבוקר. טוב לצאת לטיול ביום כזה. פסגת ההר האדימה באור השמש והדרך התפתלה לעברה עד שנבלעה בצד השני. שם השתרע עמק חדש, ואחריו הרים חדשים ...<br>
    מומינטרול עמד והביט בסנופקין, שקפל וארז את האוהל שלו.<br>
    "אתה הולך להרבה זמן?" שאל.<br>
    "לא," אמר סנופקין. "ביום הראשון של האביב שוב אהיה כאן. ואשרוק תחת החלון. שנה חולפת כל כך מהר!"<br>
    "כן," אמר מומינטרול. "אז להתראות."<br>
    "להתראות," אמר סנופקין.<br>
    מומינטרול נשאר על הגשר. הוא ראה כיצד סנופקין נעשה קטן יותר ויותר ולבסוף נעלם בין עצי הלבנה והתפוח. אבל כעבור זמן קצר שמע את מפוחית הפה שלו.<br>
    "עכשיו הוא מאושר" חשב מומינטרול.<br>
    הנגינה הלכה ונחלשה עד לבסוף השתרר שקט.<br>
    (משפחת המומינים – הסיפור על מגבעת המכשף / טובה ינסון, עמ' 140-142)<br><br>
    ככה נשארת, סנופקין נצחי, שחייב לצאת שוב ושוב, לנדוד, לחפש, להגיע לאותם מקומות נכספים, שאולי בעצם אף פעם לא מגיעים אליהם.<br>
    נראה שנותרנו לגלות בכאב גדול בכל אביב מחדש, שהאביב שוב כאן, ואתה אינך. השקט שהשתרר, נשאר. והוא ריק וכואב ומלא געגוע למי ולמה שאבד בזמן.`,
  ran5: `
    <strong>שנתיים ליונתן</strong><br><br>
    אני חושב עליך... לא, זה כבר לא כמו אז. לא כל יום. מדי פעם. הצצה חטופה בצ'אט של הוואטסאפ, של המסנג'ר. רק לשמוע את קולך בהודעה קולית או סרטון וידאו שלך.<br>
    זיכרונות מאובקים טמונים במילים שנכתבו ונאמרו אי שם -  לכאורה סתמיות, אבל במבט לאחור מעוררות געגוע גדול שאי אפשר להסביר...<br>
    שנתיים אחי.<br>
    כתבתי לך פעם, שאני לא יודע אם אני כותב לך או עליך. נראה לי שלך.. ככה מרגיש לי.<br>
    הצטרפתי לקבוצת וואטסאפ לאחרונה, שבה החברים שלך מנסים להקים אתר הנצחה עבורך. זה מוזר לי.<br>
    מה היית רוצה? מה יישאר אחרייך? שאלות שגדולות עליי כרגע...<br>
    בינתיים, ובעיקר עבורי אני חייב לציין, שמתי תמונה שלנו על השידה בחדר שינה שלי. ועשיתי קעקוע. היית מאמין? איפה שהקעקוע המכוער שלך היה. זה הרגיש לי נכון. משאיר לי אותך פה קצת יותר. קצת יותר נוכח בחיי היומיום שלי.<br>
    בסוף, אני חושב, ההנצחה היא עבורנו ופחות בשבילך - לא?<br><br>
    יונתן, אני ממש מתגעגע אליך. אתה חסר לי פה מאוד.<br>
    כל כך חבל שהלכת מאיתנו ככה.<br>
    אוהב המון ומקבל אותך ככה, כמו שאתה. באהבה אמיתית. רק רציתי שתדע.<br>
    הבן דוד הקטן שלך.`,
  moshe_2022: `
    <strong>אזכרה ליונתן 20/5/2022</strong><br><br>
    יונתן, עברו 3 שנים והכאב אינו מרפה. אני מתעורר בבוקר עם מחשבות עליך שנמשכות לאורך כל היום עד לשינה בלילה. לצערי או למזלי אינך מופיע לי בחלומות, אף פעם לא חלמתי עליך חוץ מפעם אחת נוראית בשעה 3 לפנות בוקר, 4 ימים לפני שנפלת למותך, התעוררתי בבהלה ממראה שאתה נופל ממצוק. כעבור יומיים דיברנו בטלפון אמרת  שאתה מרגיש טוב ואני ביטלתי את איתות האזהרה כסתם חלום. הימים עוברים והזיכרונות אינם עוזבים, פעולות פשוטות של יום יום מזכירות לי דברים שעשינו ביחד או דיבור שהיה לנו בהקשרים שונים. בערב כשאני צופה בטלוויזיה אני נזכר בך אומר לי "אבא הערב  יש משחק בליגה האירופית, או משחק הקלאסיקו בין ברצלונה לריאל מדריד". אנחנו צופים בשידור ולאחר זמן לא ארוך אני נרדם ולאחר כמה ניסיונות להעיר אותי אתה מתייאש.<br><br>  
    האתר לזכרך עלה לאוויר, הושקעה בו עבודה גדולה וראויים להערכה אבי צ׳יפרוט וריבה. הספקתי לעבור על רובו ולמדתי, מדברים שכתבו חברים רבים שלך, פרטים וצדדים שחיזקו את הכרותיי אותך וצדדים שלא הכרתי. החיים שלך היו אינטנסיביים הספקת לעשות ולראות בחייך הקצרים כמות אירועים שמספיקה לאנשים רבים עשייה בתקופת חיים מלאה. יחד עם הזמן הקצר הקדשת המון תשומת לב למשפחה ולחברים שהקיפו אותך ושפגשת בדרכך. נתת לכל אחד מהאנשים הרגשה שהם החברים הכי טובים שלך והם זכו במלוא תשומת הלב מצדך. ידעת לשמור על קשר עם כולם גם לאחר תקופות ארוכות שלא נפגשתם.<br><br>
    עצי המנגו מסיימים את תקופת הפריחה ומסתמן יבול טוב גם השנה. אני נזכר באהבתך הגדולה לפרי המנגו שהביא אותך לשאול מידי שנה, אבא מתי יהיה אפשר כבר לאכול מנגו, חזרתי שוב על ההסבר שההבשלה מתחילה רק בחודש אוגוסט. כואב לי מאד שאתה כבר לא תהנה מאכילת מנגו טוב.<br><br>
    החיים שנמשכים בלעדיך יש בהם פחות אור. אצלי כל דבר, כל זיכרון נמדד בשתי תקופות חיים לפני או אחרי מותך. החיים היו הרבה יותר שמחים ומוארים כאשר היית איתנו.
    `,
  rona_2022: `
    <strong>אזכרה ליונתן 20/5/2022</strong><br><br>
    שרשרת אומללה של אירועים הביאה אותנו לכאן היום מידי שנה.<br>
    את יונתן הכרתי 32 שנים. הוא היה אחד משמונת האחיינים שלי (מפוזרים בעולם) והוא היה לא הבכור ולא הצעיר (מקום באמצע).<br><br>
    השם יונתן יואל קושר את הדור הקודם של הסבא (יואל) ממזרח אירופה עם התנ״ך ועם המודרנה של ארץ ישראל. שני שמות עם הרבה משמעות במרחק של 2 דורות. הסבא של יונתן שרד את השואה, ואילו יונתן מת בגיל צעיר.<br><br>
    התראיתי עם יונתן לעיתים רחוקות, וכמעט תמיד באירועים משפחתיים. שם וליד המבוגרים, הוא היה בדר״כ שקט ומופנם. אך תמיד הרגשתי אותו מאוד נוכח ומאוד מעורב, ובמיוחד בטקסי הזיכרון לסבא יצחק וסבתא אטקה בקיבוץ, הוא היה עומד בצד בשקט, אך בשקט שלו היה מוטבע אהבה ואכפתיות למסגרת המשפחתית. חבל מאוד שתחושות אלו לעולם לא באו לידי ביטוי בצורה ורבלית ובקול רם.<br><br>
    אני זוכרת שהמשפחה המורחבת שלנו חגגה את יום ההולדת גיל 70 של הדוד חגי בערבה. יונתן היה עסוק (לא היה יכול להגיע). האירוע נמשך יומיים- יונתן הגיע בכוחות עצמו ביום השני לכמה שעות בלבד. הוא רצה לכבד את האירוע ולהיות חלק מהמשפחה, ולו למספר שעות. ללא מילים, אך במעשים, הוא העניק לנו תשומת לב ואהבה. הוא רצה שנהיה ביחד, רצה מעורבות במשפחה.<br><br>
    וזה היה יונתן שארגן לנו אירוע של יומיים בצפון, הפעם לכבוד ריבה. הוא ריכז את כל המשפחה יחד לחופשה עם לינה. לנו אירוע כזה היה נדיר, ומאז לא קיימנו מפגש כזה, כי מה? כי ״בלי יונתן זה לא קורה״.<br><br>
    אפילו שהוא גר בת״א, אני מעט מאוד נפגשתי עם יונתן, והיו תמיד סיבות ותירוצים. היום אני מודה ומתוודע שפספסתי את הילד, את הנער, את הגבר הצעיר.<br><br>
    ועכשיו זה מאוחר. אני נושאת את הכאב הזה בליבי. לא התאמצתי מספיק ולא נתתי ביטוי לאהבה שלי את יונתן. לא מספיק. אך כן הייתי עדה והייתי מודעת להתפתחות של יונתן מילד קטן למבוגר נאה, חכם, רגיש, עדין נפש ואוהב אדם.<br><br>
    יונתן, בפעם הראשונה שנפגשנו בברית מילה שלך שהתבצע על השולחן שלי בפינת האוכל בקרית ההגנה ברחובות. ובפעם האחרונה בבית הקברות כאן כשזיהיתי את גופתך יחד עם אבא משה. שם נפרדנו. אבל יונתן, איזו מן פרידה זו?<br><br>
    32 שנים. תקופה קצרה מידי לכל הדעות. המוות שלך- עובדה אכזרית וקורעת לב. זה לא היה צריך להיות כך. משהו השתבש בסדר הנכון של החיים.<br><br>
    ויונתן, איך השארת אותנו מוכי יגון, כואבים, כועסים ועם רגשות אשם.<br><br>
    יונתן, אתה בלב שלי עמוק, ועמוק בלב של כולנו. אני מעבירה לך נשיקות וחיבוקים של דודה אוהבת.
    `,
  liat_2022: `
    <strong>בהלוויה שלי</strong><br><br>
    בהלוויה שלי –<br>
    אני לא רוצה שתהיו עצובים<br>
    בלי נרות נשמה או פרחים עלובים<br>
    בלי הספד מרגש, באמת לא צריך<br>
    תבואו בכיף, ותביאו סביח!<br><br>
    בהלוויה שלי –<br>
    אל תלבשו בגד שחור<br>
    אל תחרטו אותיות של "יזכור"<br>
    תארגנו איזה די.ג'יי וקצת אלכוהול<br>
    אם למות כמו כולם, אז למות בגדול<br><br>
    בהלוויה שלי –<br>
    אל תספרו עליי שום סיפורים<br>
    "יפה, וחכם, ורגיש להורים!"<br>
    תביאו קפה ומשהו מתוק<br>
    תריצו קצת דאחקות, אני מבטיח לצחוק<br><br>
    בהלוויה שלי –<br>
    אל תפסיקו לשניה לחייך<br>
    בלי ציטוטים מ"מה אברך"<br>
    או "הוא כל כך יחסר", במבט מיוסר<br>
    תחגגו את זה שתהיו פה מחר<br><br>
    בהלוויה שלי –<br>
    תנצלו את היום שניתן עד הסוף<br>
    תצאו לטיול, תרדו אל החוף<br>
    תתחבקו כמו דובים, תגידו שטויות<br>
    תנו לי למות כמו שאהבתי לחיות.   
    `,
  riva_2023: `
  <strong>ריבה מדברת ליונתן.</strong><br>
  <strong>דודתו רונה גורן מקריאה:</strong><br><br>
    1. בראשון לספטמבר 1986, בשעה חמש וחצי אחרי הצהריים, הגעת לעולם – ושינית את חיי לנצח. קיבלתי אותך בהתרגשות רבה, אך ביחד עם לא מעט חששות ותחושת חוסר ביטחון עצמי, אחרי שנים של היסוסים בנושא האימהות. בבית החולים אפילו ביקשתי להישאר יום נוסף, מחשש שלא אסתדר! נעניתי בשלילה כמובן! אז חזרנו הביתה והתחלתי ללמוד להסתדר, עם הרבה יעוץ ועזרה, בעיקר מגיסתי רונה ומספרו של ד"ר ספוק, <b>ה</b>מומחה לגידול ילדים של אז!<br><br>
    2. בשנים הראשונות בילינו הרבה יחד, אתה ואני, בביתנו הראשון באושיות ואחרי זה בבית ברח' רמב"ם. בילינו יחד בבית ובגינה, בסידורים וקניות, בגני משחקים ובנסיעות לירושלים למפגשים עם חברות ועם אימי. גם כשהיית במשפחתונים, בגן ילדים ובבי"ס יסודי, וגם בשנים שעבדתי ובמקביל למדתי בת"א, הספקנו לבלות יחד הרבה - במפגשים עם חברים, בהצגות, בזמן ארוחות הערב ותמיד בהקראת סיפור לפני השינה, לעיתים בליווי חתולה או שתיים. דרכך הכרתי את השירים וספרי הילדים הראשונים, ונפתח בפניי עולם של קסם, כיף, צחוקים ו"ביחד". הפכת למרכז חיי ולדבר הכי חשוב לי, גם אם אולי לא תמיד הרגשת כך.<br><br>
    3. ראיתי איך אתה לוקח את צעדייך הראשונים, מתחיל לדבר, לקרוא ולכתוב, ממציא משחקים ורוכש חברים, איך אתה אוהב להתרוצץ בטבע, מתנסה בסוגי ספורט שונים – ומתאהב בכדורגל! ראיתי איך אתה מתפתח בכיוון הייחודי שלך, בדרך ובקצב שלך. ראיתי איך כבר מבית ספר יסודי אתה בוחר בקפדנות את חברייך לבילויים ולמסיבות שלך, בניגוד למסיבות הכיתתיות המקובלות של שאר הילדים. ראיתי איך אתה יודע לבנות חברות עם אנשים שמתאימים לך ולשמור עלייה.<br><br>
    4. ואז הגעת לבי"ס תיכון. יום אחד קצת אחרי תחילת שנה"ל, הלכת עם חבר למפגש של הצופים. שם פגשת קבוצה של כ-15 בנים שאיתם מצאת חיבור מיוחד – AND THE REST IS HISTORY! הצטרפת לחבורה שהפכה לימים לקבוצת ה"אחים". בילית וטיילת איתם בארץ ובחו"ל ודאגת לשמור על הקשר המיוחד לאורך כל השנים, קשר שנמשך עד היום. מיד אחרי ששמעו על האסון, הגיעו ה"אחים" לביתנו ונשארו כדי לעטוף, לחבק וללוות. יחד, פתחנו אתר הנצחה מקוון לזיכרונך וגיבשנו רעיונות לאתר הנצחה בטבע - אתר שייקרא "גן יונתן" ושחלק מהחברים מעורבים בהקמתו. היו כמובן עוד חברים רבים טובים, שגם איתם נפגשת וטיילת הרבה בארץ ובחו"ל – מביה"ס, מהצבא, מהאוניברסיטה, ממידברן ומהטיולים עצמם. אהבת את כל חברייך וגם ידעת לחבר ביניהם, לאחד וליצור אווירה של ביחד. וגם עכשיו, למרות שאתה לא פה פיזית, אתה ממשיך לעשות זאת דרך מפגשים כמו של היום.<br><br>
    5. עם תהליך ההתבגרות, היחסים בינינו השתנו. הפסקת לשתף אותי ברגשות ובחוויות שלך כמו פעם. קיבלתי את זה כתהליך בריא וטבעי, וראיתי שתפקידי הולך והופך לתפקיד של <u>"מספקת שירותים"</u>. הבנתי שתפקידי החדש כולל טיפול בנושאים שלא אהבת להתעסק בהם - בנקאות, מס הכנסה, פנסיות, קופת חולים... בנוסף לשרותי כביסה, אספקת מאכלים טובים, ציוד לדירה – וכל זה בלי לשאול הרבה שאלות. שמחתי שזכיתי לתפקיד כלשהו והשתדלתי למלאו בלי שאלות "חופרות". ניסיתי "לשחרר" ותמיד לזכור מה שאמרת לי כשפרשתי מהעבודה: <b>"אוי, עכשיו יהיה לך עוד יותר זמן להתערב לי בעניינים!"</b> השתדלתי להתאפק ולחכות שהיוזמה להתערבות תבוא ממך!<br><br>
    6. את דפוס התקשורת שלמדתי בבית הוריי אפשר לסכם במילה אחת – <u>דאגה</u>. כך הוריי הביעו את אהבתם אליי. לא יכולתי אחרת אלא להפוך לאמא דאגנית כפייתית, וכך באמת היה לאורך כל חייך. היו עליות מדרגה ברמת הדאגה, למשל כשקיבלת רישיון נהיגה והתחלת לצאת עם האוטו בערב. לפעמים הייתי הולכת לישון מוקדם כי ידעתי שאתעורר בסביבות 2-3 בבוקר כדי לחכות לך. רק אחרי ששמעתי את המפתח בדלת הכניסה ודלת המקרר נפתחת, רק אז הייתי חוזרת לישון. עליית מדרגה נוספת הייתה במהלך שנות שרותך בצבא, אבל העליות הרציניות היו בטיולי הטבע שלך בחו"ל. עם כל מייל או שיחת טלפון איתך, נרגעתי זמנית ואז שוב התחלתי לחכות בחרדה לשיחה הבאה.<br><br>
    7. פיתחתי תאוריה לגבי חשיבות הדאגה - ראיתי את זה כסוג של הגנה מפניי סכנות: כלומר, אם אצפה לתרחישים רעים, אז יש סיכוי טוב שהם לא יתממשו. <u><b>טעיתי</b></u>. שלושה חדשים אחרי חיבוקינו האחרון בנתב"ג, ובדיוק כשהתחלתי להירגע ולהשתכנע שהכל יהיה בסדר, <u>בדיוק אז זה קרה</u>. קיבלת החלטה לא חכמה, החלטה שביחד עם חילוץ בעייתי, הובילה לסוף הטרגי. מה שעשית זה מפתיע, אבל גם לא מפתיע: מפתיע כי תמיד היית מאוד יסודי וקפדני בתכנון הטרקים, אבל לא מפתיע כי לא ידעת לוותר על שום דבר, ובטח שלא על טיפוס על הר געש. הכל היה נראה לך מעניין ודורש בדיקה לעומק. אף פעם לא הבנתי את הדחף הבלתי נשלט הזה, את הצורך לחקור הכל, לחוות את הטבע עד הסוף. כל אחד שטייל איתך ראה וחווה את זה, לטוב ולרע, וגם לא ידע להסביר.<br><br>
    8. ב-17.5.2019, בשעה 6.30 לפי שעון ישראל, כשלבך הפסיק לפעום, באותו רגע נורא קרס עולמי. נעלמה לנצח "האני" הישנה ואת מקומה תפסה "אני" חדשה, אישה שבורה ומאוד עצובה. נעלמה מהלקסיקון שלה קטגוריה שלמה של מושגים – שמחה, אושר, התלהבות, התרגשות ועוד הרבה. היא גם "שכחה" איך לחייך – שרירי הפנים מתקשים ליצור את התנועות הנחוצות. ברכות פשוטות כמו <u>"בוקר טוב"</u> ו<u>"חג שמח"</u> צורמות, כי בעולם בלעדייך לא יכול להיות בוקר <u>באמת</u> טוב או חג <u>באמת</u> שמח.<br><br>
    9. אנחנו לוקחים כמובנים מאליהם את האנשים היקרים לנו ולא חושבים עליהם באופן מתמיד, אבל כשהם מתים אנחנו פתאום חושבים עליהם כל הזמן. אני חושבת עליך מיליון פעם כל יום. חושבת עלייך כשאני עוברת ליד המקומות בהם היית איתי וגם בלעדיי – המשפחתונים, גני הילדים, בתי הספר, בניין הצופים, בתי החברים – וגם כשאני עוברת ליד
המאכלים והמצרכים שאהבתי לקנות לך. חושבת עליך כשאני נוסעת בירושלים ברחביה, ונזכרת בכל הנסיעות שלך הלוך וחזור אלינו, עם שקיות הכביסה והצידניות. חושבת עלייך בארוחות שישי, שבת וחג, ובשבת בבוקר ב-7.30 שהיית בא הביתה אחרי משמרת לילה במכון הגיאופיסי. חושבת עלייך כשמדברים על מקום בו טיילת או שנראה לי שהיית רוצה לטייל בו, כמו איסלנד. חושבת עלייך בטיולים <u>שלי</u>, כמו בגיאורגיה, ולאחרונה בדרום אפריקה כשראינו מבנים גיאולוגים המזכירים את המבנים באזור ים המלח שחקרת לתזה שלך. חשבתי עלייך הרבה לפני כמה חדשים בזמן רעידות האדמה בטורקיה ובארץ, ונזכרתי במה שכתבת בתזה על ההשלכות המעשיות של המחקר שלך לגבי תכנון בנייה ופיתוח מערכות התרעה לרעדות אדמה – תרומתך הקטנה למדע! אני עדיין "רואה אותך" במקומות שונים, ובכל פעם שאני רואה יונדאי גץ' לבן אני בודקת אם הראי השמאלי שבור. חושבת עלייך כל לילה לפני השינה וכל בוקר כשאני מתעוררת. ולפעמים בלילות מאוד קרים, אני חושבת על הלילה האחרון שלך על ההר ההוא, שחיכית בחושך ובקור המקפיא לחילוץ שלקח כמעט יום שלם להגיע, וליבי מתרסק במכת כאב בלתי נסבל. חושבת על העתיד האבוד של שנינו, על החלומות שלא יתגשמו. חושבת עלייך מיליון פעמים נוספות כל יום, בלי קשר לשום מקום ובלי שום סיבה מיוחדת – פשוט חושבת, מתגעגעת ומתאבלת.<br><br>
10. אני לא מצליחה להפנים לגמרי שאתה לא כאן - זה לא יכול להיות, זה לא הגיוני. כל כך הרבה פעמים חיכיתי שתחזור אליי - מבית הספר, מפגשים, בילויים, עבודה, טיולים – שנים של המתנה, ותמיד חזרת. זה בלתי אפשרי שכל זה נגמר סופית. כל כך הרבה דברים יש לי לספר ולהגיד לך. לא אמרתי לך כמה שאני גאה בך, באדם הטוב והאכפתי שהפכת להיות, באנושיות ובערכיות שלך ובכל הישגייך. לא אמרתי לך כמה שאני אוהבת אותך, התינוק המתוק שלי, הילד החמוד שלי, הנער הרציני שגם ידע לצחוק ושכבר לא רצה להיות רק שלי, הגבר החתיך עם כל כך הרבה תקוות ושאיפות - הבן שלי. לעולם לא איפרד ממך. אשא אותך בליבי ובנשמתי כל ימי חיי, עם האהבה, הכאב והגעגועים האין סופיים.
    `,
  riva_2024: `
    <strong>נכתב ע״י ריבה גורן.</strong><br><br>
    1. דפיקה בדלת לא צפויה, צלצול בטלפון באמצע הלילה... ההודעה יכולה לבוא בדרכים שונות ומפתיעות, אבל ברגע שהיא מגיעה, החיים משתנים מקצה לקצה ומה שהיה קודם כבר לא יהיה.  להורה, זה הרגע בו הוא מבין שהפחד הכי גדול שלו התממש, שהחשש שהתחיל מהפעם הראשונה שהילד יצא מהבית בלעדיו הפך למציאות.  בחודשים האחרונים יש יותר מדי הודעות, ולא רק להורים אלא גם לבני משפחה אחרים– לבני זוג, אחים ואחיות, סבים וסבתות, בני דודים, ילדים ונכדים...<br><br>

    2. מה-7.10 כל אמצעי התקשורת המקומיים משדרים אין סוף ידיעות על משפחות ההרוגים - על הלוויות, המשפחות והסיפורים האישיים. עם כל הודעה שמתחילה במילים <b>"הותר לפרסום שמו של..."</b>, ליבי יוצא למשפחה ואני חושבת על מה שאני מתארת לי שעובר עליהם. בהתחלה, בזמן ההלם הראשוני, הם עוד לא יודעים מה מחכה להם, איזה דרך ארוכה וכואבת לפניהם. אתה יודע שקרה משהו נורא ואתה יכול לקלוט את העובדות, אבל אתה עוד לא מסוגל להפנים את משמעות האירוע לעומקו. במהלך החיים רובנו חווים מדי פעם חוויות קשות, הפתעות לא נעימות שלעיתים גם מטלטלות. עם רובן אנחנו מצליחים להתמודד ובאיזשהו שלב גם להשלים ולהמשיך הלאה, במידה זו או אחרת. אבל האירועים הגדולים באמת דורשים זמן להיקלט, לחלחל פנימה ללב ולנפש, להיספג בתודעה ולהפוך לחלק מהמציאות החדשה שלך. ואתה עוד לא יודע שכל זה ישאר איתך לנצח. במהלך השבעה אצלנו, שאלתי מישהי שבנה נהרג מספר שנים לפניכן מתי אחזור להרגיש שוב "נורמלי" כמו קודם. היא הביטה בי, חייכה ולא ממש ענתה לי. לאט לאט הבנתי שהתשובה היא למעשה "אף פעם". לוקח זמן להבין את המשמעות האמיתית והעמוקה של הדבר הנורא שקרה, להבין שעם אירוע כמו איבוד של ילד אין "להתמודד, להשלים ולהמשיך הלאה". המושג הנפוץ בתרבות המערבית closure אינו רלוונטי.<br><br>

    3. בזמן האחרון אני חושבת הרבה על המושגים <b>"ביחד"</b> ו<b>"לבד"</b>, בעיקר ברמה האישית ללא קשר לרמה החברתית הרחבה.  אולי זה ישמע הזוי, אבל אם נגזר עליי לחיות בעולם השכול, אני קצת מקנאה במשפחות החיילים שנהרגו, כי נדמה לי שיש להן את ה"ביחד", את השייכות למשהו משמעותי – הבנים הרי נפלו למטרה ברורה ומקודשת, בהגנה על המדינה. וגם יש להם את החיבוק, העטיפה והתמיכה של צה"ל, למרות שאני יודעת שלא כל המשפחות מקבלות את הנרטיב ויש כאלה עם ביקורת קשה על הצבא. אני גם יודעת שעם כל הנחמה שבאה מה"ביחד", מהמיתוס ומהגאווה, החיים והמציאות היומיומיים הם קצת שונים. כמו שאמר גבי אייזנקוט בראיון עם אילנה דיין לפני כמה חדשים: <b>"אתה הולך לישון עם זה בלילה וקם עם זה בבוקר"</b>. בסופו של דבר, כל הורה שכול הוא לבד. את הכאב הפרטי שלו הוא נושא ותמיד יישא לבד, בלי קשר למי הוא, כמה הוא עסוק במהלך היום, במה הוא עסוק וכמה הוא מעורב בדאגה לאחרים.<br><br>

    4. אני גם חושבת הרבה על נושא הבחירה ושליטה בחיים, ומיד חושבת על ההרוגים הראשונים ב-7.10 מיישובי הדרום וממסיבת ה"נובה" ועל הבזבוז הנוראי של חיים. אני חושבת על איך הם הופתעו באמצע החיים ונלכדו במצבים שנכפו עליהם, מבלי יכולת לבחור ולהשפיע על גורלם. ואז אני חושבת עליך, יונתן, על איך לך כן היו אפשרויות בחירה. בחרת מרצונך החופשי בפעילות מסוכנת, בידיעה שהיא מסוכנת (בזה אני די בטוחה). כל מוות של אדם צעיר ובריא הוא דבר שלא צריך לקרות, דבר מיותר,  אבל שלך מיותר אף יותר, לפחות בשבילי. יכולת להחליט אחרת ולחיות את החיים שלך בכל דרך שהיית בוחר.<br><br>

    5. אני חושבת לעיתים על איך יכלו להיות החיים שלך היום אם היית בחיים. קרו הרבה דברים גדולים במדינה בדיוק בשנים שאתה לא פה, ועצוב לי שאני לא יכולה לדבר איתך על אף אחד מהם. יש כל כך הרבה  דברים שהייתי רוצה לשוחח איתך עליהם, הרבה שאלות ותהיות. איך היית מסתדר בתקופת הקורונה, מבחינת עבודה וחברה? ובתוקפת  המחאות, מה היית חושב על כל הנושא? האם היית משתתף בהפגנות? ועכשיו המלחמה. השאלה המיידית שלי היא כמובן האם היית מתגייס למילואים? ואם לא, איך היית בוחר לתרום? אני בטוחה שהיית מיד מרגיש חובה להיות מעורב, לתרום בצורה משמעותית ולהיות חלק מהגל הענקי של מעורבות שהתחיל כבר ב-7.10. אני בטוחה שהיית מיד מתחבר ל"ביחד" – זה בדיוק מה שאהבת בצבא, במידברן ועיסוקים נוספים, בדיוק מה שתמיד חיפשת, חווית  השייכות לרעיון משמעותי. כשאני רואה את המילואימניקים ברחוב או בטלוויזיה, אני חושבת עלייך ומדמיינת שגם אתה ביניהם. כמה שזה נשמע משונה, מאוד עצוב לי שאתה  לא פה כדי להשתתף בחוויה הענקית הזאת, עם כל הקושי בה, גם אם היית מתגייס ומסתכן בעזה או בצפון.  אני בטוחה שהייתי גאה בכל מה שהיית בוחר לעשות.<br><br>

    6. עברו חמש שנים ומה השתנה אצלי? אתה עדיין מלווה אותי בכל מקום ובכל מה שאני עושה, מאי שם ברקע. יש דברים שעוזרים לי לחיות ככה לידך, שמאפשרים לי בריחה והסחת דעת מהכאב, ושגם מביאים לי מעט נחמה - מפגשים עם חברים, סרטים, טיולים, החתולים שלי ואפילו קניות! אני כבר מסוגלת להתרכז בנושאים שכלל לא קשורים אלייך. אתה תמיד שם מתחת לפני השטח, מאחורי הקלעים, אבל אני כבר לא שקועה בחשיבה ודיבורים מתמידים ואובססיביים עלייך כמו קודם. איך להסביר את השינוי הזה? נראה לי שבני אדם לא מסוגלים לחיות בסבל נפשי עוצמתי לזמן בלתי מוגבל. הכאב נוטה להתעמם עם הזמן, כמנגנון טבעי להגנה והישרדות. עם זאת, אצלי ההפוגות מהחשיבה עלייך הן לא ארוכות. פתאום באמצע עיסוק כלשהו אתה חוזר אליי, והמפגש איתך גורם לי כאב כל כך חד שאני חייבת שוב לברוח, להתרחק זמנית למקום פחות כואב. אז תסלח לי, יונתן, אם אני חושבת ומדברת עלייך פחות. זה לא אומר שאיכפת לי פחות, שאני פחות אוהבת אותך, שאני מתחילה לשכוח ולנטוש אותך. זה פשוט יותר מדי כואב להיזכר בכל מה שהיה פעם ואיננו עוד. הכאב, הגעגועים והעצב העצומים הם בלתי נסבלים. אז למדתי לברוח ולשתוק. אני זוכרת את הכל, כל זיכרון שקשור אליך חרוט בי באיזשהו מקום.  לעולם לא אשכח ולא אנטוש אותך. אתה הדבר היקר ביותר שהיה לי בחיים, האושר הגדול ביותר ועכשיו הכאב הגדול ביותר. תישאר לנצח חלק ממני, עם כל האושר והכאב.<br><br>
    `,
  riva_2025: `
    <strong>נכתב ע״י ריבה גורן - 23.5.2025</strong><br><br>
    
    כולנו זוכרים את שירי, אריאל וכפיר ביבס. מי שצפה בטלוויזיה בלוויה העצובה כל כך אולי
הופתע מסוג השירים שירדן בחר להשמיע לזכרם במהלך הלוויה. במקום שירים ישראלים
מתוך מגוון השירים ה&quot;מתאימים&quot; מהז&#39;אנרים הצפויים, הוא בחר שירים לא מוכרים,
באנגלית, של להקות רוק זרות. אחד מהם דיבר אליי במיוחד - <b>Hold On to Memories</b> ("תשמרו על זיכרונות") - שיר שלדעתי דווקא מאוד התאים לאירוע, וגם
נושא מסר משמעותי מאוד לכל מי שאיבד אדם יקר לו. מאוד התחברתי והחלטתי לפתוח
את ההספד שלי עם חלק מהמילים של השיר:<br><br>
    
    
    <i>...Hold on to memories"</i><br><b>תשמרו על זיכרונות</b><br>
    <i>Hold on to every moment, to keep them alive<br><b>תאחזו בכל רגע, כדי לשמור אותם חיים</b><br>
    <i>The world's greatest tragedy (is that) souls who are not remembered cannot survive"</i><br>
    <b>הטרגדיה הגדולה ביותר היא שנשמות שלא נזכרות אינן מסוגלות לשרוד"</b><br><br>
    
    וזה בדיוק מה שאנחנו עושים כאן היום. אנחנו שומרים על זיכרונותינו על יונתן, כדי
שנשמתו תשרוד, כדי לזכור שהיה בן אדם בשם יונתן גורן, שהיה חבר לחלק גדול מכם,
חבר קרוב לכמה מכם, בן דוד ואחיין לבני משפחתו – והבן האהוב והיקר שלי. אנחנו
זוכרים, ועל ידי כך דואגים שנשמתו תשרוד.<br><br>
    
    אני חושבת בזמן האחרון על הקשר בין לזכור, להתאבל ולהנציח. לפני זמן מה שמעתי
הרצאה מאדם שסיפר על בית ילדותו. סיפורו אינו יוצא דופן – יש רבים שדומים לו. זמן
קצר אחרי השואה, הגיעו הוריו כצעירים ממזרח אירופה לארה״ב, אחרי שאיבדו בשואה
קרובי משפחה רבים. שם באמריקה הכירו, התחתנו, הקימו משפחה - ושם הוא נולד. וכך
הוא מתאר את ביתו: בבית בו הוא גדל לא הייתה כלל אווירה של אבל. <u>הוריו אף פעם לא
התאבלו</u>. לא דיברו על העבר, לא הזכירו בני משפחה וחברים שנספו ולא ציינו שום דבר
שקשור לעבר - כאילו שחייהם התחילו רק אחרי שהגיעו לאמריקה. בזמן שהקשבתי
לתיאור של ילדותו, תהיתי אם בכל זאת היו להוריו רגעים פרטיים של צער וגעגועים,
רגעים ששמרו בפנים רק לעצמם - כך שהילדים פשוט לא ידעו ולא הרגישו בכאבם.<br><br>
    
    אחרי החוויות הקשות שהוריו ורבים כמוהם עברו, אפשר בהחלט להבין את בחירותיהם,
את הדחף לברוח כדי לשרוד, את הצורך לשים מאחורה את העבר הנורא ולהתמקד
בעתיד וביצירת מציאות לגמרי חדשה. אבל יחד עם זה, טבעי גם לחשוב ולהתאבל מדי
פעם על האנשים שאהבנו ושאינם עוד, אם כל הקושי בדבר. הרי גם בעלי חיים
מתאבלים. רואים את זה לפי שינוים בהתנהגותם – כלב שמאבד אדם או בעל חי שהיה
קשור אליו נעשה לא שקט וחסר שמחת חיים, פילים קוברים את המתים ושומרים על
מקום הקבורה, וגם קופים ודולפינים מפגינים סמני צער כשמאבדים בעל חי קרוב.<br><br>
    
    אז מה זה התאבלות עבור בני אנוש? ברור שבני אדם הם יותר מורכבים מבעלי חיים.
נדמה לי שבגדול, הדרך בה רובינו מתאבלים מושפעת ממגוון רחב של גורמים והשילוב
ביניהם – בעיקר תרבות ומסורת, אמונה, גורמים אישיים ונסיבות ספציפיות. בהתאם לכל
זה, כל אדם מחליט איך לבטא את צערו – אם זה קשור לדרכי קבורה, אזכרה, תפילות,
הקמת אנדרטה, תיעוד כלשהו, יצירה אומנותית או כל פעולה אחרת שנראית לו מתאימה.
אבל לפי דעתי, אפשר גם להתאבל בשקט, בלי ביטויים חיצוניים, גם אם העולם לא רואה
ולא שומע את הבכי השקט שבלב.<br><br>
    
   קראתי משהו על תהליך ההתאבלות שנראה לי רלוונטי. תרגמתי חלק ממנו לעברית:
<b>לאבל אין ציר זמן, ואין דרך &quot;נכונה&quot; להתאבל ... בהתחלה, זה מרגיש בלתי נסבל,
כמו פצע פתוח שלעולם לא יגליד. אבל אם הזמן, הקצוות הטריים מתחילים
להתאחות. הכאב מתרכך, אבל חותמו נשאר – תזכורת שקטה של מה שהיה פעם.
האמת היא שאתה אף פעם לא ממש &quot;ממשיך הלאה&quot;. אתה רק ממשיך עם זה</b>.
מילים שמזכירות אולי שיר אחר, שיר שיותר מוכר לנו - <b>&quot;פחות אבל עוד כואב&quot;</b><br><br>

    יונתן אף פעם לא ממש רחוק ממני. הזיכרונות והמחשבות באות אלי בלי הזמנה ובלי
סיבה כלשהי, בזמן שאני מנסה לחיות את החיים – באמצע מפגש כלשהו, ארוחה, סרט,
הרצאה, טיול או כמעט כל דבר. ואז אני חושבת עליו אבל לא מדברת, כמעט ולא מצליחה
להזכיר את שמו בקול רם. זה פשוט כואב מדי. למילה המדוברת יש כוח מיוחד – היא
עושה את הכל אמיתי וחזק יותר. הדיבורים מכריחים אותי להסתכל, חסרת הגנה, &quot;בעיני&quot;
מציאות בלתי מתפשרת, ומפגישים אותי עם הסופיות הבלתי נמנעת של האובדן. זה גדול
עליי. אז אני בוחרת להקל על עצמי מעט ולא מדברת הרבה על מה שבלב. זאת הדרך
שלי להמשיך עם זה, לעת עתה.<br><br>
    
   אני חושבת שהביטויים החיצוניים של צער והתאבלות באים לא רק מצורך פרטי אישי,
אלא גם מצורך חברתי. כיצורים חברתיים וקהילתיים, יש לנו לפעמים צורך לשתף אחרים
במה שעובר עלינו, להודיע לאחרים שאנחנו זקוקים להבנה, חמלה, נחמה ולפעמים גם
חיבוק. לדעתי זאת גם דרך לבקש מאחרים לעזור לנו לשמור על הזיכרונות של האדם
שאיבדנו, ועל ידי כך גם לעזור לנו להנציח את זכרו.<br><br>
    
   מעבר להנצחה ברמה של זיכרונות ומחשבות, לרבים מאיתנו יש גם שאיפה להנצחה
מוחשית. לעיתים אנחנו מיישמים זאת דרך פעילויות מאורגנות מיוחדות (כמו אירועי
ספורט או טיולים עם תרמילים מיוחדים). לפעמים אנחנו מחפשים ביטוי אף יותר מוחשי
ומקימים אתרי הנצחה פיזיים ממשיים (כמו אנדרטות או גנים ציבוריים). לגבי הנצחתו של
יונתן ,אנחנו פועלים בכל הרמות ובכמה כיוונים, עם דגש לאחרונה על הרמה המוחשית.
כפי שידוע לרובכם, נכנסנו לפני כמה שנים לפרויקט עם עיריית רחובות להקמת פארק
לזכרו. הפארק ייקרא &#39;פארק יונתן&#39; ואנחנו שמחים לבשר שיש לאחרונה התקדמות
משמעותית בדרך להקמתו. בנוסף לפארק, ישנה אפשרות חדשה להנצחה פיזית נוספת
בפרויקט קטן יותר עם המוזיאון למדע בירושלים. פרויקטים אלה מספקים לנו נחמה
מסוימת ותקווה שהם אכן יתרמו להנצחת זכרו של יונתן. כך אנחנו מקווים להמשיך
לשמור על זיכרונותינו שלו לאורך שנים.<br><br>
    `,
  moshe_2025: `
    <strong>נכתב ע״י משה גורן</strong><br><br>
    
    עברו כבר 6 שנים מאז שאתה איננו איתנו. קשה לבטא את הרגשות שעולות לי
בעקבות הזיכרונות הרבים: למגע ביננו, לדברים שעשינו ביחד, לשיחות שנהלנו,
מחשבות שלך בנושאים שונים, נהגת להתייעץ איתי בדילמות שעמדו לפניך,
בד&quot;כ לא היו לי תשובות נחרצות, אלא רק דרכי פעולות אפשריות הנתונות
להחלטה שלך. כיף היה לגדל אותך, לראות אותך הופך מילד ביישן מלא חששות
לנער עם ביטחון עצמי, פתוח לנעשה סביבו ומג בש דעות אישיות. סקרן ובעל
יוזמות לפעילות, אוהב להפתיע עם מחוות למשפחה ולחברים. התגייסת לצבא
עם חשש גדול האם תהיה לך מספיק נחישות, אומץ ויכולת, האם תוכל לעמוד
בדרישות. לא רצית לשרת ביחידה מיוחדת, אלא סתם בגדוד תותחנים. לאחר
חודשים מעטים ביחידת העילית מורן הרגשת שהיחידה קטנה עליך, לא מספיק
קרבית וניסית לעבור ליחידה נועזת יותר.<br><br>
    
אהבת מאד לבקר בקיבוץ משמר השרון של סבא וסבתא ובילית בו בחופשות.
חבל היה לך שאנחנו לא גרים בקיבוץ כמו בני הדודים שלך. שאלת אותי לא פעם
למה עזבתי את הקיבוץ לחיות בעיר.<br>
    
    החיים המהירים מלאי התרחשויות וחידושים שצצים כל שני וחמישי הקשו על
ההסתגלות והעמידה בקצב, לא התאימו לך. לעיתים סירבת לאמץ טכנולוגיות
חדשות. דוגמא יפה לכך היה הטלפון הסלולרי דור ישן פרימיטיבי, שסירבת
להחליף עם מכשיר סמארט-פון מתקדם בטענה שהמכשיר הישן שלך מספיק
טוב ועונה על הצרכים שלך. כעבור שנים כאשר הטלפון הישן התפרק, הסכמת
לקבל ממני פלאפון חדש שקניתי כמתנה לכבוד יום ההולדת שלך. אחת הסיבות
להסכמה הייתה כדי שתוכל לעקוב אחר המשחקים של מכבי תל-אביב.<br><br>
    
    הבעת בפני את האכזבה שלא נולדת בדור קודם כמוני, בטענה שהיית מרגיש
הרבה יותר שייך לחברה למדינה, ויכול להזדהות עם המטרות המשותפות.<br>
המוות המוקדם שלך מנע ממך לחיות בתקופה הנוכחית שבה המדינה משתנה
במהירות, החמס כבש את הנגב המערבי רצח ושבה מאות אנשים, הביטחון
נפגע וחבלי ארץ שלמים בצפון ובדרום הופקרו ונעזבו. במדינה כל המוסדות
וצורות החיים שהיו לנו נהרסים, נוצר קיטוב והשנאה בחברה. הממשלה לא
מצליחה לשלוט ולענות על צורכי הציבור בדברים הבסיסיים ביותר.<br>אני בטוח שלא היית אוהב את מה שקורה במדינה שאהבת ואולי הידיעה הזו
נחסכה ממך.<br><br>

    החברים שלך שומרים על קשר איתנו ואנחנו מלווים אותם ועוקבים אחרי איך הם
מתקדמים בחיים, הקימו משפחות, נולדו להם ילדים והם מבססים את ביתם.
צד השמחה על הצלחותיהם יש לנו עצב קטן בלב, שאנחנו לא זכינו. הגעגועים
אליך לא פוחתים עם הזמן, אפילו מתגברים.<br><br>

`,
  riva_2026: `
  <strong>נכתב ע״י ריבה גורן - 15.5.2026</strong><br><br>

  עברו שבע שנים בלי יונתן - שבע שנים ארוכות של כאב וגעגועים מתמשכים, שבע שנים רעות מאוד. ובניגוד לסיפור התנכי על שנים טובות ורעות, אינני מצפה ששבע השנים הבאות תהינה טובות יותר מאלה שעברו. להיפך, סביר יותר שהן תהינה די דומות לאחרונות. לרעיון של תפנית כלשהי אחרי שבע שנים אין שום רלוונטיות עבורי.<br><br>

  הזמן הוא מושג מורכב. הוא פועל ברמות שונות במקביל, על צירי זמן נפרדים. ברמה הפיזיקאלית האובייקטיבית, פועל שעון הזמן האוניברסלי. לפי שעון זה, הזמן נמדד לפי היחידות המוכרות בכל העולם - דקות, שעות, ימים, שבועות, חודשים ושנים. שעון זה מתקדם בקביעות בכיוון אחד ואי אפשר לעצור אותו. אבל במקביל לזה, יש לדעתי לכל אחד גם שעון פנימי, שהוא אישי וסובייקטיבי. שעון זה מושפע ממצבו הרגשי והנפשי הייחודי של כל אדם, וזה מה שקובע את קצב התקדמות של השעון הפנימי. לשעון זה אני קוראת שעון הרגשות, הלב והנפש. שעון הלב שלי נעצר בבת אחת בשעה 6.30 בבוקר ב-17 למאי  2019, כשנדם ליבו של יונתן. שם נקפא הזמן הפנימי שלי, שם כלוא ליבי. השעון האוניברסלי ממשיך כמובן להתקדם כרגיל ללא מרפה, אבל השעון הפנימי שלי לא מסונכרן איתו. הוא נשאר מאחור ופועל לפי קצב משלו. אני חיה, מתפקדת ומתנהלת בעולם כמו כולם לפי השעון החיצוני, אבל עם עולם פנימי שצובע את הכול, איך אני רואה את העולם ואיך אני מתנהלת בו, אם זה באופן ישיר או עקיף.<br><br>

  אומרים ש"הזמן עושה את שלו", שהוא "מרפה את הכול". אצלי הזמן אכן עושה משהו, אבל המשהו הזה הוא מורכב. עם הזמן, הכאב אכן נעשה פחות חד וחותך, והפצע מתחיל להגליד. אני יוצאת למפגשים וטיולים ואפילו נהנית קצת, וגם  התחלתי לצחוק ואפילו לחייך מעט. אבל את כל זה אני עושה עם לב כבד והרבה פחות שימחה מקודם. ביחד עם הקלות קטנות כאלה, יש גם רגעים של כאב ועצב עמוק. ככל שעוברות השנים, מצד אחד, נעשה יותר קל להתרחק מהמחשבות עליך ולנשום יותר בקלות. אבל מצד שני, החזרה הבלתי נמנעת אליך נעשית לעיתים יותר כואבת. גם נושא ההנצחה נעשה מורכב: עם הזמן, כל התעסקות בסיפור שלך מאשרת ומדגישה יותר ויותר את העובדה שאתה באמת כבר לא פה.<br><br>

  עם כל הכאב בזה, אני עדיין חושבת עלייך כשאני עוברת במקומות בהם היית, ועדיין רואה אותך ואת האוטו שלך. אני עדיין מתגעגעת לכל מה שהיה, להתעסקות עם הכביסה, המאכלים, הקניות, הסידורים וכל ההתארגנויות סביבך – גם הדברים שביקשת וגם אלה שלא, גם הדברים המהנים וגם הפחות מהנים. אני מתגעגעת לשיחות שלנו, כולל החיכוכים הקטנים, ואפילו לימי הדאגה עליך, לשעות ההמתנה עד ששוב שמעתי אותך או שראיתי אותך. גם הרגעים הקשים היו חלק מתחושת המשמעותיות והמטרה שהענקת לחיי.  אתה עדיין פשוט חסר לי, וכל כך עצוב לי שכבר אין לי אותך בחיי.<br><br>

  כשאני רואה את הצעירים סביבי, אינני יכולה לא לתהות מה היה יכול להתרחש אצלך ב-7 השנים שעברו, מה היית יכול לעשות, לחוות ולהשיג, ומה עוד יכול היה להיות בעתיד. היית אמור לחגוג בקרוב יום הולדת 40 - גיל של אדם מבוסס, עם מקצוע ועבודה מסודרת, אולי גם עם משפחה משלך. לפעמים, כשאני חושבת על האובדן והבזבוז חיים הענקי, פתאום עולה בדעתי המחשבה שלא יכול להיות שקרה דבר כל כך נורא וכל כך סופי. זה נורא מכדי שזה באמת קרה, פשוט בלתי אפשרי. שכשהמחשבות והזיכרונות קשים מדי, אני בתגובה אינסטינקטיבית מרחיקה אותם ובורחת לאיזושהי הסחת דעת, למקום בטוח יותר.  אני כל יום מודה למי שהביא לישראל את NETFLIX!<br><br>

  אז מה יהיה בשנים הבאות? לעיתים אני מרגישה שאני בהמתנה למשהו – משהו לא מוגדר אבל אולי קצת יותר טוב, איזושהי הפתעה נעימה - אף על פי שההיגיון אומר לי שזה לא סביר. בינתיים אני יכולה רק להמשיך לקוות שבעתיד הלא רחוק אכן יקומו שני האתרי הנצחה שקידמנו: פארק הטבע העירוני ברחובות, ופרויקט נוסף שיזמנו לאחרונה - חדר להדמיית רעידות אדמה במוזיאון המדע בירושלים. עם כל הכאב שמלווה את נושא ההנצחה, יש בי גם תקווה שזה ייתן מעט נחמה. עד אז, אנסה להמשיך להביע את מחשבותיי ורגשותיי בדרך עקיפה זו, במילים שלי אך בקול של מי שמוכן להשמיע אותן.<br><br>
`,
  moshe_2026: `
<strong>נכתב ע״י משה גורן - 15.5.2026</strong><br><br>
(הספד אביו של יונתן באזכרה - 15-5-2026)
`,
};

export const memorialText = `
זמן קצר אחרי שיונתן נפטר, התחילו חברים שונים להכין אלבומים וחוברות מיוחדים, יצירתיים ומרגשים, אשר מהווים סוג של הנצחה.  רק אחרי שנה התחלנו (הוריו) לחשוב על דרכים משלנו להנציחו. חשבנו, התייעצנו, דיברנו עם חבריו ועוד אנשים, ביררנו כיוונים שונים, ולבסוף גיבשנו 3 רעיונות נפרדים שיפעלו במקביל, עם אפשרות להוסיף רעיון רביעי.<br><br>
<strong><u>אתר האינטרנט הזה</u></strong><br>האתר הוקם ביוזמתו של אבי, חבר קרוב של יונתן, שהחליט כשנה אחרי פטירתו של חברו לקחת את זה על עצמו כפרויקט. אחרי כמעט שנתיים של השקעה, בהן גם התייעץ ונעזר בחברים נוספים, נפתח האתר - בשעה טובה ומוצלחת!<br><br>
<strong><u>"גן יונתן" – אתר בטבע</u></strong><br>
הגשנו בקשה לעיריית רחובות להקים על שמו של יונתן אתר הנצחה בטבע באזור העיר. מתוך השטחים שהוצעו לנו, בחרנו שטח מול הספורטק רחובות, עליו יקום פארק גדול כפרויקט משותף בינינו לעירייה. הפארק כולו ייקרא "גן יונתן" ויכלול מרכיבים שרלונתיים לנו (אנדרטה, אזורים לישיבה, למפגשים והליכה וגם מרכז למידה), בנוסף למרכיבים שפחות קשורים אלינו. התהליך הוא איטי ועלול לקחת מספר שנים (בשל גודל ומורכבות הפרויקט וגם טבע הבורוקטייה...), אך נראה לנו שהתוכנית מתחילה לרקום עור וגידים.<br><br>
<strong><u>עמותת "משא למסע"</u></strong><br>העמותה היא מיזם הנצחה שעיקרו השאלת תרמילים למטיילים.  כל תרמיל מנציח מטייל/ת שנהרג/ה, ונתרם על ידי בני משפחתם או חבריהם. על כל תרמיל תפור פאץ' עליו שם האדם המונצח, ובכיס נמצאת חוברת המספרת עליו. לעמותה יש גם אתר אינטרנט פעיל, עם קישור לעמוד אישי לכל מונצח אשר מוביל למידע ותמונות עליו. בעמוד זה, יכול המטייל ללמוד יותר על המונצח וגם לכתוב על חוייותיו בטיולו עם התרמיל.<br>
כששמעתי על העמותה, התרשמתי שהרעיון הוא מתאים לרוחו של יונתן. מספר שבועות אחרי שהצטרפתי, הגיעו התרמילים המוכנים למחסנים, ודי מהר יצא לדרך התרמיל הראשון!<br>
<u><a href="https://masa-lamasa.org" target="_blank">https://masa-lamasa.org</a></u><br><br>
<strong><u>פינה באחד הפארקים של ק.ק.ל</u></strong><br>
בנוסף לפנייתנו לעירייה רחובות, פנינו גם לק.ק.ל. בבקשה לקבל אתר הנצחה באחד הפארקים שלהם. עדיין לא הוצע לנו משהו מתאים, אך אם אכן יתממש הרעיון, הוא יופעל במקביל ל"גן יונתן".`;

// c_scale,f_auto,q_auto:low,w_1000/
export const eulogy_2019 = {
  title: '2019',
  details: null,
  topicImages: [
    {
      category: '1',
      title: 'משה גורן',
      description: 'אביו של יונתן בהלוויה - 24-5-2019',
      images:
        'https://res.cloudinary.com/yonatan-memorial/image/upload/c_scale,f_auto,q_auto:low,w_1000/v1620415119/DayAfter/moshe_j9helf.jpg',
      text: eulogy.moshe_goren,
    },
    {
      category: '2',
      title: 'אהוד רייס',
      description: 'חבר ילדות בהלוויה - 24-5-2019',
      images:
        'https://res.cloudinary.com/yonatan-memorial/image/upload/c_scale,f_auto,q_auto:low,w_1000/v1620415435/DayAfter/ehud_ttflj8.jpg',
      text: eulogy.ehud,
    },
    {
      category: '3',
      title: 'טום נרקיס',
      description: 'חבר מהצבא בהלוויה - 24-5-2019',
      images:
        'https://res.cloudinary.com/yonatan-memorial/image/upload/c_scale,f_auto,q_auto:low,w_1000/v1620416134/DayAfter/tom_l1bwup.jpg',
      text: eulogy.tom,
    },
    {
      category: '4',
      title: 'רן גורן',
      description: 'בן דודו של יונתן בהלוויה - 24-5-2019',
      images:
        'https://res.cloudinary.com/yonatan-memorial/image/upload/c_scale,f_auto,q_auto:low,w_1000/v1620416617/DayAfter/ran1_expq1g.jpg',
      text: eulogy.ran1,
    },
    {
      category: '5',
      title: 'רן גורן',
      description: 'בן דודו של יונתן בשלושים - 21-6-2019',
      images:
        'https://res.cloudinary.com/yonatan-memorial/image/upload/c_scale,f_auto,q_auto:low,w_1000/v1620416620/DayAfter/ran4_ob8t0m.jpg',
      text: eulogy.ran2,
    },
    {
      category: '6',
      title: 'רן גורן',
      description: 'בן דודו של יונתן ביום הולדתו - 1-9-2019',
      images:
        'https://res.cloudinary.com/yonatan-memorial/image/upload/c_scale,f_auto,q_auto:low,w_1000/v1620416618/DayAfter/ran3_jjcca9.jpg',
      text: eulogy.ran3,
    },
    {
      category: '7',
      title: 'חברים מהמידברן',
      description: 'חבריו של יונתן מאירועי המידברן',
      images:
        'https://res.cloudinary.com/yonatan-memorial/image/upload/c_scale,f_auto,q_auto:low,w_1000/v1620416880/DayAfter/midburn_qdaxha.jpg',
      text: eulogy.midburn,
    },
    {
      category: '8',
      title: 'יואב יחיה',
      description: 'חבר ילדות מקדיש ליונתן את התזה',
      images:
        'https://res.cloudinary.com/yonatan-memorial/image/upload/c_scale,f_auto,q_auto:low,w_1000/v1620415435/DayAfter/yoav_pnymw4.jpg',
      text: eulogy.yoav,
    },
  ],
};

export const eulogy_2020 = {
  title: '2020',
  details: null,
  topicImages: [
    {
      category: '1',
      title: 'אדם ברק',
      description: 'חבר ילדות באזכרה - 15-5-2020',
      images:
        'https://res.cloudinary.com/yonatan-memorial/image/upload/c_scale,f_auto,q_auto:low,w_1000/v1620415436/DayAfter/adam_s6niyo.jpg',
      text: eulogy.adam_barak,
    },
    {
      category: '2',
      title: 'רן גורן',
      description: 'בן דודו של יונתן באזכרה - 15-5-2020',
      images:
        'https://res.cloudinary.com/yonatan-memorial/image/upload/c_scale,f_auto,q_auto:low,w_1000/v1620416619/DayAfter/ran2_mseqdt.jpg',
      text: eulogy.ran4,
    },
  ],
};

export const eulogy_2021 = {
  title: '2021',
  details: null,
  topicImages: [
    {
      category: '1',
      title: 'שירה',
      description: 'בת דודה של יונתן באזכרה - 4-6-2021',
      images:
        'https://res.cloudinary.com/yonatan-memorial/image/upload/c_scale,f_auto,q_auto:low,w_1000/v1644215315/DayAfter/yonatan_shira.jpg',
      text: eulogy.shira,
    },
    {
      category: '2',
      title: 'רן גורן',
      description: 'בן דודו של יונתן באזכרה - 4-6-2021',
      images:
        'https://res.cloudinary.com/yonatan-memorial/image/upload/c_scale,f_auto,q_auto:low,w_1000/v1620416617/DayAfter/ran1_expq1g.jpg',
      text: eulogy.ran5,
    },
  ],
};

export const eulogy_2022 = {
  title: '2022',
  details: null,
  topicImages: [
    {
      category: '1',
      title: 'רונה גורן',
      description: 'דודה של יונתן באזכרה - 20-5-2022',
      images:
        'https://res.cloudinary.com/yonatan-memorial/image/upload/c_scale,f_auto,q_auto:low,w_1000/v1653760333/DayAfter/rona_2022_mmxk85.jpg',
      text: eulogy.rona_2022,
    },
    {
      category: '2',
      title: 'משה גורן',
      description: 'אביו של יונתן באזכרה - 20-5-2022',
      images:
        'https://res.cloudinary.com/yonatan-memorial/image/upload/c_scale,f_auto,q_auto:low,w_1000/v1653760582/DayAfter/moshe_2022_jxayac.jpg',
      text: eulogy.moshe_2022,
    },
    {
      category: '3',
      title: 'ליאת שבתאי',
      description: 'ידידה מהמידברן באזכרה - 20-5-2022',
      images:
        'https://res.cloudinary.com/yonatan-memorial/image/upload/c_scale,f_auto,q_auto:low,w_1000/v1653760716/DayAfter/liat_2022_qeifc7.jpg',
      text: eulogy.liat_2022,
    },
  ],
};

export const eulogy_2023 = {
  title: '2023',
  details: null,
  topicImages: [
    {
      category: '1',
      title: 'ריבה גורן - אני ויונתן, יונתן ואני',
      description: 'אימו של יונתן באזכרה - 29-5-2023',
      images:
        'https://res.cloudinary.com/yonatan-memorial/image/upload/c_scale,f_auto,q_auto:low,w_1000/DayAfter/riva_2023.jpg',
      text: eulogy.riva_2023,
    },
  ],
};

export const eulogy_2024 = {
  title: '2024',
  details: null,
  topicImages: [
    {
      category: '1',
      title: 'דפיקה בדלת',
      description: 'אימו של יונתן באזכרה - 17-5-2024',
      images:
        'https://res.cloudinary.com/yonatan-memorial/image/upload/c_scale,f_auto,q_auto:low,w_1000/DayAfter/riva_2023.jpg',
      text: eulogy.riva_2024,
    },
  ],
};
export const eulogy_2025 = {
  title: '2025',
  details: null,
  topicImages: [
    {
      category: '1',
      title: '6 שנים ליונתן',
      description: 'אביו של יונתן באזכרה - 23-5-2025',
      images:
        'https://res.cloudinary.com/yonatan-memorial/image/upload/c_scale,f_auto,q_auto:low,w_1000/v1749714688/DayAfter/riva_2025.jpg',
      text: eulogy.moshe_2025,
    },
    {
      category: '2',
      title: 'לזכור, להתאבל ולהנציח – מחשבות והרהורים',
      description: 'אימו של יונתן באזכרה - 23-5-2025',
      images:
        'https://res.cloudinary.com/yonatan-memorial/image/upload/c_scale,f_auto,q_auto:low,w_1000/v1749714872/DayAfter/moshe_2025.jpg',
      text: eulogy.riva_2025,
    },
  ],
};

export const eulogy_2026 = {
  title: '2026',
  details: null,
  topicImages: [
    {
      category: '1',
      title: 'זמן',
      description: 'אימו של יונתן באזכרה - 15-5-2026',
      images:
        'https://res.cloudinary.com/yonatan-memorial/image/upload/v1780515286/DayAfter/time_a5tlcr.png',
      text: eulogy.riva_2026,
    },
  ],
};

export const eulogy_moniPaper = {
  title: 'moniPaper',
  details: null,
  topicImages: [
    {
      category: 'moniPaper',
      title: 'moniPaper',
      description: 'הספדים מ2019',
      images:
        'http://drive.google.com/uc?export=view&id=19laYrj48y1kn97aMcdH2Yi8-tPrFCmSW',
    },
  ],
};

export const memorial = {
  title: 'topicImages',
  details: null,
  topicImages: [
    {
      category: 'memorial',
      title: 'הנצחה',
      description: 'הנצחה',
      images:
        'http://drive.google.com/uc?export=view&id=19laYrj48y1kn97aMcdH2Yi8-tPrFCmSW',
      text: memorialText,
    },
  ],
};

export const inHisMemoryPage = {
  title: 'inHisMemory',
  details: null,
  topicImages: [
    {
      category: 'annualEvents',
      title: 'אירועים חד-שנתיים',
      description: inHisMemoryDesc.annualEvents,
      images: inHisMemoryImages.annualEvents,
    },
    {
      category: 'memoryEvening',
      title: 'ערב זוכרים את יונתן –  ת"א 29.6.2019',
      description: inHisMemoryDesc.memoryEvening,
      images: inHisMemoryImages.memoryEvening,
    },
    {
      category: 'burningMan',
      title: 'Burning Man Nevada - 25.8-2.9.2019',
      description: inHisMemoryDesc.burningMan,
      images: inHisMemoryImages.burningMan,
    },
    {
      category: 'aizicTrip',
      title: 'אייל אייזיק בטיול לזכרו 2020',
      description: inHisMemoryDesc.aizicTrip,
      images: inHisMemoryImages.aizicTrip,
    },
    {
      category: 'midburn2021',
      title: 'מידברן 2021',
      description: inHisMemoryDesc.midburn2021,
      images: inHisMemoryImages.midburn2021,
    },
    {
      category: 'midburn2022',
      title: 'מידברן 2022',
      description: inHisMemoryDesc.midburn2022,
      images: inHisMemoryImages.midburn2022,
    },
    {
      category: 'maccabiVsMarmorek',
      title: 'משחק גביע המדינה מכבי תל אביב נגד הפועל מרמורק 19/12/2021',
      description: inHisMemoryDesc.maccabiVsMarmorek,
      images: inHisMemoryImages.maccabiVsMarmorek,
    },
  ],
};

export const homeImages = [
  {
    category: 'lifeStory',
    title: 'סיפור חיים',
    description:
      // lifeStory.details ??
      'סיפור חייו של יונתן החל מילדותו, דרך בית הספר, צבא, אוניברסיטה ועד חייו הבוגרים',
    // description: 'טקסט כלשהו',
    url: 'https://res.cloudinary.com/yonatan-memorial/image/upload/c_scale,f_auto,q_auto:low,w_1000/v1620240669/HomePage/firstYears_flkaql.jpg',
    topicPage: '/galleries/lifeStory',
  },
  {
    category: 'friends',
    title: 'חברים',
    description:
      // friends.details ??
      'ליונתן היו מעגלי חברים רבים. הגרעין היה חבריו מבית אך בכל מקום אשר היה רכש לעצמו חברים חדשים',
    url: 'https://res.cloudinary.com/yonatan-memorial/image/upload/c_scale,f_auto,q_auto:low,w_1000/v1620240668/HomePage/frinds_fow7gk.jpg',
    topicPage: '/galleries/friends',
  },
  {
    category: 'travel',
    title: 'טיולים בעולם',
    description:
      // travel.details ??
      'ליונתן היתה אהבה גדולה לטיולים. תקציר מטיוליו הרבים בעולם מתוארים בחלק זה',
    url: 'https://res.cloudinary.com/yonatan-memorial/image/upload/c_scale,f_auto,q_auto:low,w_1000/v1620242876/HomePage/travel_hr77vu.jpg',
    topicPage: '/galleries/travel',
  },
  {
    category: 'hobbies',
    title: 'עיסוקים ותחביבים',
    description:
      // hobbies.details ??
      'עסק וצפה בענפי ספורט רבים, בצעירותו היה חלק מתנועת הצופים ובחייו הבוגרים מקהילת המידברן',
    // 'בנוסף לענפי הספורט בהם יונתן עסק וצפה, בצעירותו היה חלק מתנועת הצופים ובחייו הבוגרים מקהילת המידברן',
    url: 'https://res.cloudinary.com/yonatan-memorial/image/upload/c_scale,f_auto,q_auto:low,w_1000/v1620240168/HomePage/hobbies_lai6z6.jpg',
    topicPage: '/galleries/hobbies',
  },
  {
    category: 'dayAfter',
    title: 'לזכרו',
    description:
      // dayAfter.details ??
      'חלק זה יוקדש להספדים, ארועים לזכרו, סרטונים וזכרונות נוספים',
    url: 'https://res.cloudinary.com/yonatan-memorial/image/upload/c_scale,f_auto,q_auto:low,w_1000/v1620240669/HomePage/dayAfter_scz1n2.jpg',
    topicPage: '/dayAfter',
  },
];
